// import React, { useEffect, useState, useRef } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import Layout from "../../Layout/Layout";
// import FooterNew from "../../Layout/FooterNew";

// // const API_URL = "https://ecom.cyberathon.com/index.php/Api/list_video";
// const API_URL = "https://ecom.cyberathon.com/index.php/Api/get_list_product";
// const BASE_URL = "https://ecom.cyberathon.com/";
// const FREE_SECONDS = 10;

// // ─── Helpers ─────────────────────────────────────────────────────────────────
// function detectVideoType(url) {
//   if (!url || url.trim() === "") return "no-video";
//   const u = url.toLowerCase();
//   if (u.includes("youtube.com") || u.includes("youtu.be")) return "youtube";
//   if (
//     u.endsWith(".mp4") || u.endsWith(".webm") || u.endsWith(".ogg") ||
//     u.includes(".mp4?") || u.includes("gtv-videos-bucket") ||
//     u.includes("commondatastorage.googleapis.com") || u.includes("archive.org")
//   ) return "mp4";
//   if (u.includes("vimeo.com") || u.includes("dailymotion.com")) return "iframe";
//   return "mp4";
// }

// function buildYouTubeEmbedUrl(raw) {
//   try {
//     if (raw.includes("watch?v=")) {
//       const id = new URLSearchParams(new URL(raw).search).get("v");
//       return `https://www.youtube.com/embed/${id}`;
//     }
//     if (raw.includes("youtu.be/")) return `https://www.youtube.com/embed/${raw.split("youtu.be/")[1].split("?")[0]}`;
//     if (raw.includes("embed/")) return raw;
//   } catch (e) {}
//   return raw;
// }

// function getYouTubeId(embedUrl) {
//   if (!embedUrl) return "";
//   const match = embedUrl.match(/embed\/([^?&]+)/);
//   return match ? match[1] : "";
// }

// function loadYouTubeAPI() {
//   if (window.YT && window.YT.Player) return Promise.resolve();
//   if (window.__ytApiPromise) return window.__ytApiPromise;
//   window.__ytApiPromise = new Promise((resolve) => {
//     window.onYouTubeIframeAPIReady = resolve;
//     const tag = document.createElement("script");
//     tag.src = "https://www.youtube.com/iframe_api";
//     document.body.appendChild(tag);
//   });
//   return window.__ytApiPromise;
// }

// const HtmlContent = ({ html, className = "" }) => {
//   if (!html) return null;
//   return <div className={className} dangerouslySetInnerHTML={{ __html: html }} />;
// };

// async function addToCartApi(prod_id, onSuccess, onError) {
//   const userId = sessionStorage.getItem("userId");
//   if (!userId) { alert("Please login first!"); return; }
//   try {
//     const res = await axios.post(
//       "https://ecom.cyberathon.com/index.php/Api/insert_cart",
//       { user_id: Number(userId), prod_id: Number(prod_id), qty: 1 }
//     );
//     if (res.data.status === true) onSuccess();
//     else onError(res.data.message || "Failed to add");
//   } catch (e) { onError("Something went wrong"); }
// }

// // ─── Video Player Section ─────────────────────────────────────────────────────
// const VideoPlayer = ({ video, isPurchased, isAdded, onAddedChange }) => {
//   const [phase, setPhase] = useState("idle"); // idle | playing | locked | error
//   const videoRef = useRef(null);
//   const timerRef = useRef(null);
//   const playerRef = useRef(null);
//   const [loading, setLoading] = useState(false);
//   const divId = `detail-yt-${video.id}`;

//   const videoId = video.type === "youtube" ? getYouTubeId(video.embedUrl) : null;
//   const thumbUrl = videoId ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg` : null;

//   // MP4 preview timer
//   useEffect(() => {
//     if (phase !== "playing" || video.type !== "mp4") return;
//     const vid = videoRef.current;
//     if (!vid || isPurchased) return;
//     const onPlay = () => {
//       timerRef.current = setTimeout(() => { vid.pause(); setPhase("locked"); }, FREE_SECONDS * 1000);
//     };
//     vid.addEventListener("play", onPlay);
//     return () => { vid.removeEventListener("play", onPlay); clearTimeout(timerRef.current); };
//   }, [phase, isPurchased, video.type]);

//   const handlePlay = async () => {
//     if (video.type === "youtube") {
//       setPhase("playing");
//       await loadYouTubeAPI();
//       setTimeout(() => {
//         playerRef.current = new window.YT.Player(divId, {
//           events: {
//             onReady: (e) => {
//               e.target.playVideo();
//               if (!isPurchased) {
//                 timerRef.current = setTimeout(() => {
//                   e.target.pauseVideo();
//                   setPhase("locked");
//                 }, FREE_SECONDS * 1000);
//               }
//             },
//           },
//         });
//       }, 300);
//     } else {
//       setPhase("playing");
//     }
//   };

//   const handleReplay = () => {
//     clearTimeout(timerRef.current);
//     if (playerRef.current) { try { playerRef.current.destroy(); } catch (e) {} playerRef.current = null; }
//     setPhase("idle");
//   };

//   useEffect(() => () => {
//     clearTimeout(timerRef.current);
//     if (playerRef.current) { try { playerRef.current.destroy(); } catch (e) {} }
//   }, []);

//   const handleCartFromLock = async () => {
//     setLoading(true);
//     await addToCartApi(
//       video.prod_id,
//       () => { onAddedChange(true); setLoading(false); },
//       (msg) => { alert(msg); setLoading(false); }
//     );
//   };

//   // No-video
//   if (video.type === "no-video") {
//     return (
//       <div className="vd-player-wrap vd-no-video">
//         <svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1.2">
//           <rect x="2" y="2" width="20" height="20" rx="2.5" />
//           <path d="M10 8l6 4-6 4V8z" />
//           <line x1="2" y1="2" x2="22" y2="22" />
//         </svg>
//         <p>No video available for this course</p>
//       </div>
//     );
//   }

//   return (
//     <div className="vd-player-wrap">
//       {/* Badge */}
//       {isPurchased ? (
//         <span className="vd-badge vd-badge-purchased">
//           <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
//           Full Access Unlocked
//         </span>
//       ) : (
//         <span className="vd-badge vd-badge-preview">
//           <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21" /></svg>
//           {FREE_SECONDS}s Free Preview
//         </span>
//       )}

//       {/* IDLE state */}
//       {phase === "idle" && (
//         <>
//           {video.type === "youtube" && thumbUrl ? (
//             <img src={thumbUrl} alt={video.heading} className="vd-thumb" />
//           ) : video.type === "mp4" ? (
//             <video src={`${video.embedUrl}#t=0.5`} className="vd-thumb" preload="metadata" muted playsInline />
//           ) : (
//             <div className="vd-thumb" style={{ background: "#0d1117" }} />
//           )}
//           <div className="vd-play-overlay" onClick={handlePlay}>
//             <div className="vd-play-ripple" />
//             <button className="vd-play-btn">
//               <svg width="28" height="28" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21" /></svg>
//             </button>
//             <p className="vd-play-hint">Click to play {isPurchased ? "full video" : "free preview"}</p>
//           </div>
//         </>
//       )}

//       {/* PLAYING */}
//       {phase === "playing" && (
//         <>
//           {video.type === "youtube" && (
//             <iframe
//               id={divId}
//               src={`https://www.youtube.com/embed/${videoId}?enablejsapi=1`}
//               title={video.heading}
//               allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
//               allowFullScreen
//               style={{ width: "100%", height: "100%", border: "none", display: "block" }}
//             />
//           )}
//           {video.type === "mp4" && (
//             <video
//               ref={videoRef}
//               src={video.embedUrl}
//               controls={isPurchased}
//               autoPlay
//               playsInline
//               onError={() => setPhase("error")}
//               style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
//             />
//           )}
//           {video.type === "iframe" && (
//             <iframe
//               src={video.embedUrl}
//               title={video.heading}
//               allow="autoplay; fullscreen"
//               allowFullScreen
//               style={{ width: "100%", height: "100%", border: "none", display: "block" }}
//             />
//           )}
//         </>
//       )}

//       {/* LOCKED */}
//       {phase === "locked" && (
//         <>
//           {/* blurred bg */}
//           {video.type === "youtube" && thumbUrl && (
//             <img src={thumbUrl} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", filter: "blur(8px) brightness(0.3)" }} />
//           )}
//           <div className="vd-lock-overlay">
//             <div className="vd-lock-ring" />
//             <div className="vd-lock-icon">
//               <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <rect x="3" y="11" width="18" height="11" rx="2" />
//                 <path d="M7 11V7a5 5 0 0 1 10 0v4" />
//               </svg>
//             </div>
//             <h3 className="vd-lock-title">Preview Ended</h3>
//             <p className="vd-lock-sub">Purchase this course to watch the full video</p>
//             <div className="vd-lock-actions">
//               {video.prod_id && (
//                 <button
//                   className={`vd-btn-cart${isAdded ? " added" : ""}`}
//                   onClick={handleCartFromLock}
//                   disabled={loading || isAdded}
//                 >
//                   {loading ? <span className="vd-spinner" /> :
//                     isAdded ? (
//                       <><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg> Added to Cart</>
//                     ) : (
//                       <><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" /></svg> Add to Cart</>
//                     )}
//                 </button>
//               )}
//               <button className="vd-btn-replay" onClick={handleReplay}>
//                 <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="1 4 1 10 7 10" /><path d="M3.51 15a9 9 0 1 0 .49-6" /></svg>
//                 Replay Preview
//               </button>
//             </div>
//           </div>
//         </>
//       )}

//       {/* ERROR */}
//       {phase === "error" && (
//         <div className="vd-error">
//           <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="1.5"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
//           <p>Video could not be loaded</p>
//           <button className="vd-btn-retry" onClick={() => setPhase("idle")}>Try Again</button>
//         </div>
//       )}
//     </div>
//   );
// };

// // ─── MAIN DETAIL PAGE ─────────────────────────────────────────────────────────
// const CourseSectionDetailPage = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [video, setVideo] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isPurchased, setIsPurchased] = useState(false);
//   const [isAdded, setIsAdded] = useState(false);
//   const [cartLoading, setCartLoading] = useState(false);
//   const [relatedVideos, setRelatedVideos] = useState([]);

//   useEffect(() => {
//     const load = async () => {
//       try {
//         const res = await axios.get(API_URL);
//         if (!res.data.status) { setLoading(false); return; }

//         // const all = res.data.videos.map((v) => {
//         //   let rawUrl = v.video || "";
//         //   if (rawUrl && !rawUrl.startsWith("http")) rawUrl = BASE_URL + rawUrl;
//         //   const type = detectVideoType(rawUrl);
//         //   let embedUrl = rawUrl;
//         //   if (type === "youtube") embedUrl = buildYouTubeEmbedUrl(rawUrl);
//         //   return { ...v, type, embedUrl };
//         // });

//         const all = res.data.products
//   .filter(p => p.product_type === "coursesection")
//   .map((p) => {
//     let rawUrl = p.video || p.product_video || "";

//     if (rawUrl && !rawUrl.startsWith("http")) {
//       rawUrl = BASE_URL + rawUrl;
//     }

//     const type = detectVideoType(rawUrl);

//     let embedUrl = rawUrl;
//     if (type === "youtube") {
//       embedUrl = buildYouTubeEmbedUrl(rawUrl);
//     }

//     return {
//       ...p,
//       type,
//       embedUrl,
//     };
//   });

//         const found = all.find((v) => String(v.prod_id) === String(id));
//         setVideo(found || null);
//         setRelatedVideos(all.filter((v) => String(v.prod_id) !== String(id)).slice(0, 4));

//         // Check purchased + cart
//         const userId = sessionStorage.getItem("userId");
//         const cartToken = localStorage.getItem("cart_token");

//         if (userId || cartToken) {
//           try {
//             const cr = await axios.post("https://ecom.cyberathon.com/index.php/Api/list_cart", {
//               user_id: userId || null,
//               cart_token: userId ? null : cartToken,
//             });
//             if (cr.data.status && found?.prod_id) {
//               const inCart = cr.data.cart_items.some((i) => String(i.prod_id) === String(found.prod_id));
//               setIsAdded(inCart);
//             }
//           } catch (e) {}
//         }

//         if (userId && found?.prod_id) {
//           try {
//             const or = await axios.post("https://ecom.cyberathon.com/index.php/Api/list_new_order", {
//               user_id: parseInt(userId),
//             });
//             if (or.data.status && Array.isArray(or.data.orders)) {
//               const purchased = or.data.orders.some((order) =>
//                 Array.isArray(order.items) &&
//                 order.items.some((item) => {
//                   if (String(item.prod_id) !== String(found.prod_id)) return false;
//                   return (
//                     item.access === "unlocked" ||
//                     order.purchase_status === "yes" ||
//                     order.payment_status === "Paid" ||
//                     order.payment_status === "paid" ||
//                     order.order_status === "Delivered" ||
//                     order.order_status === "Completed"
//                   );
//                 })
//               );
//               setIsPurchased(purchased);
//             }
//           } catch (e) {}
//         }
//       } catch (e) {
//         console.error(e);
//       } finally {
//         setLoading(false);
//       }
//     };
//     load();
//     window.scrollTo(0, 0);
//   }, [id]);

//   const handleAddToCart = async () => {
//     if (isAdded || !video?.prod_id) return;
//     setCartLoading(true);
//     await addToCartApi(
//       video.prod_id,
//       () => { setIsAdded(true); setCartLoading(false); },
//       (msg) => { alert(msg); setCartLoading(false); }
//     );
//   };

//   if (loading) {
//     return (
//       <>
//         <style>{detailStyles}</style>
//         <div className="vd-root">
//           <div className="vd-skeleton-wrap">
//             <div className="vd-skeleton" style={{ height: 480, borderRadius: 20, marginBottom: 32 }} />
//             <div className="vd-skeleton" style={{ height: 28, width: "60%", marginBottom: 16 }} />
//             <div className="vd-skeleton" style={{ height: 16, width: "80%", marginBottom: 10 }} />
//             <div className="vd-skeleton" style={{ height: 16, width: "70%" }} />
//           </div>
//         </div>
//       </>
//     );
//   }

//   if (!video) {
//     return (
//       <>
//         <style>{detailStyles}</style>
//         <div className="vd-root">
//           <div className="vd-not-found">
//             <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.2"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
//             <h2>Course Not Found</h2>
//             <p>This course doesn't exist or has been removed.</p>
//             <button className="vd-back-btn" onClick={() => navigate(-1)}>← Go Back</button>
//           </div>
//         </div>
//       </>
//     );
//   }

//   const hasPaid = video.current_price && Number(video.current_price) > 0;

//   return (
//     <>
//     <Layout/>
//       <style>{detailStyles}</style>
//       <div className="vd-root">

//         {/* ── Breadcrumb ── */}
//         <div className="vd-breadcrumb">
//           <button onClick={() => navigate(-1)} className="vd-back-link">
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="15 18 9 12 15 6" /></svg>
//             Back to Courses
//           </button>
//           <span className="vd-breadcrumb-sep">/</span>
//           <span className="vd-breadcrumb-current">{video.heading}</span>
//         </div>

//         {/* ── Main Layout ── */}
//         <div className="vd-layout">

//           {/* LEFT — Video + Info */}
//           <div className="vd-main">

//             {/* Video Player */}
//             <VideoPlayer
//               video={video}
//               isPurchased={isPurchased}
//               isAdded={isAdded}
//               onAddedChange={setIsAdded}
//             />

//             {/* Title + Meta */}
//             <div className="vd-info-block">
//               <div className="vd-title-row">
//                 <h1 className="vd-title">{video.heading}</h1>
//                 {isPurchased && (
//                   <span className="vd-purchased-chip">
//                     <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>
//                     Purchased
//                   </span>
//                 )}
//               </div>

//               {/* Mobile sticky CTA */}
//               <div className="vd-mobile-cta">
//                 <div className="vd-price-row">
//                   {hasPaid ? (
//                     <>
//                       <span className="vd-price-current">₹{Number(video.current_price).toLocaleString("en-IN")}</span>
//                       {video.old_price && Number(video.old_price) > 0 && (
//                         <span className="vd-price-old">₹{Number(video.old_price).toLocaleString("en-IN")}</span>
//                       )}
//                     </>
//                   ) : (
//                     <span className="vd-price-free">Free</span>
//                   )}
//                 </div>
//                 {video.prod_id && !isPurchased && (
//                   <button
//                     className={`vd-btn-add-mobile${isAdded ? " added" : ""}`}
//                     onClick={handleAddToCart}
//                     disabled={cartLoading || isAdded}
//                   >
//                     {cartLoading ? <span className="vd-spinner" /> :
//                       isAdded ? <><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg> Added</> :
//                       <><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" /></svg> Add to Cart</>
//                     }
//                   </button>
//                 )}
//               </div>

//               {/* Tabs */}
//               <div className="vd-tabs-section">
//                 {video.description && (
//                   <div className="vd-section">
//                     <h3 className="vd-section-title">
//                       <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
//                       About This Course
//                     </h3>
//                     <div className="vd-html-content">
//                       <HtmlContent html={video.description} />
//                     </div>
//                   </div>
//                 )}

//                 {video.details && (
//                   <div className="vd-section">
//                     <h3 className="vd-section-title">
//                       <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 11 12 14 22 4" /><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" /></svg>
//                       What You'll Learn
//                     </h3>
//                     <div className="vd-html-content vd-learn-list">
//                       <HtmlContent html={video.details} />
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* RIGHT — Sticky Sidebar */}
//           <div className="vd-sidebar">
//             <div className="vd-sidebar-card">
//               {/* Preview image */}
//               <div className="vd-sidebar-thumb">
//                 {video.type === "youtube" && getYouTubeId(video.embedUrl) ? (
//                   <img src={`https://img.youtube.com/vi/${getYouTubeId(video.embedUrl)}/hqdefault.jpg`} alt={video.heading} />
//                 ) : video.type === "mp4" ? (
//                   <video src={`${video.embedUrl}#t=0.5`} muted playsInline preload="metadata" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//                 ) : (
//                   <div style={{ width: "100%", height: "100%", background: "linear-gradient(135deg,#0d1117,#1a2332)", display: "flex", alignItems: "center", justifyContent: "center" }}>
//                     <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1.2"><rect x="2" y="2" width="20" height="20" rx="2.5" /><path d="M10 8l6 4-6 4V8z" /></svg>
//                   </div>
//                 )}
//                 <div className="vd-sidebar-thumb-overlay">
//                   <svg width="22" height="22" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21" /></svg>
//                 </div>
//               </div>

//               {/* Price */}
//               <div className="vd-sidebar-price-row">
//                 {hasPaid ? (
//                   <>
//                     <span className="vd-sidebar-price-current">
//                       ₹{Number(video.current_price).toLocaleString("en-IN")}
//                     </span>
//                     {video.old_price && Number(video.old_price) > 0 && (
//                       <>
//                         <span className="vd-sidebar-price-old">
//                           ₹{Number(video.old_price).toLocaleString("en-IN")}
//                         </span>
//                         {/* <span className="vd-discount-chip">
//                           {Math.round(((Number(video.old_price) - Number(video.current_price)) / Number(video.old_price)) * 100)}% OFF
//                         </span> */}
//                       </>
//                     )}
//                   </>
//                 ) : (
//                   <span className="vd-sidebar-price-free">Free</span>
//                 )}
//               </div>

//               {/* CTA buttons */}
//               {!video.prod_id ? (
//                 <div className="vd-no-purchase">
//                   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
//                   Not available for purchase
//                 </div>
//               ) : isPurchased ? (
//                 <div className="vd-owned-block">
//                   <div className="vd-owned-badge">
//                     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>
//                     You own this course
//                   </div>
//                   <p className="vd-owned-sub">You have full lifetime access</p>
//                 </div>
//               ) : (
//                 <div className="vd-cta-stack">
//                   <button
//                     className={`vd-btn-addcart${isAdded ? " added" : ""}`}
//                     onClick={handleAddToCart}
//                     disabled={cartLoading || isAdded}
//                   >
//                     {cartLoading ? (
//                       <span className="vd-spinner vd-spinner-teal" />
//                     ) : isAdded ? (
//                       <>
//                         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>
//                         Added to Cart
//                       </>
//                     ) : (
//                       <>
//                         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" /></svg>
//                         Add to Cart
//                       </>
//                     )}
//                   </button>
//                 </div>
//               )}

//               {/* Perks */}
//               <ul className="vd-perks">
//                 <li>
//                   <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2"><polyline points="20 6 9 17 4 12" /></svg>
//                   Lifetime access after purchase
//                 </li>
//                 <li>
//                   <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2"><polyline points="20 6 9 17 4 12" /></svg>
//                   Watch on any device
//                 </li>
//                 <li>
//                   <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2"><polyline points="20 6 9 17 4 12" /></svg>
//                   Free {FREE_SECONDS}s preview available
//                 </li>
//               </ul>
//             </div>

//             {/* Related Videos */}
//             {relatedVideos.length > 0 && (
//               <div className="vd-related">
//                 <h3 className="vd-related-title">More Courses</h3>
//                 <div className="vd-related-list">
//                   {relatedVideos.map((rv) => {
//                     const rvId = rv.type === "youtube" ? getYouTubeId(rv.embedUrl) : null;
//                     return (
//                       <div
//                         key={rv.id}
//                         className="vd-related-item"
//                         onClick={() => navigate(`/coursesection/${rv.prod_id}`)}
//                       >
//                         <div className="vd-related-thumb">
//                           {rvId ? (
//                             <img src={`https://img.youtube.com/vi/${rvId}/hqdefault.jpg`} alt={rv.heading} />
//                           ) : rv.type === "mp4" ? (
//                             <video src={`${rv.embedUrl}#t=0.5`} muted playsInline preload="metadata" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//                           ) : (
//                             <div className="vd-related-no-thumb">
//                               <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1.5"><rect x="2" y="2" width="20" height="20" rx="2" /><path d="M10 8l6 4-6 4V8z" /></svg>
//                             </div>
//                           )}
//                           <div className="vd-related-play">
//                             <svg width="10" height="10" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21" /></svg>
//                           </div>
//                         </div>
//                         <div className="vd-related-info">
//                           <p className="vd-related-name">{rv.heading}</p>
//                           <p className="vd-related-price">
//                             {rv.current_price && Number(rv.current_price) > 0
//                               ? `₹${Number(rv.current_price).toLocaleString("en-IN")}`
//                               : "Free"}
//                           </p>
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//       <FooterNew/>
//     </>
//   );
// };

// // ─── STYLES ──────────────────────────────────────────────────────────────────
// const detailStyles = `
//   @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=DM+Sans:ital,wght@0,400;0,500;0,600;1,400&display=swap');

//   :root {
//     --vd-teal: #0ecfce;
//     --vd-teal-dark: #0ab5b4;
//     --vd-green: #22c55e;
//     --vd-green-dark: #16a34a;
//     --vd-text-primary: #0f172a;
//     --vd-text-secondary: #475569;
//     --vd-text-muted: #94a3b8;
//     --vd-surface: #f7fffe;
//     --vd-card-bg: #ffffff;
//     --vd-border: #e5f0f0;
//     --vd-sidebar-w: 340px;
//   }

//   .vd-root {
//     background: var(--vd-surface);
//     min-height: 100vh;
//     padding: 28px 0 80px;
//     font-family: 'DM Sans', sans-serif;
//   }

//   /* ── BREADCRUMB ── */
//   .vd-breadcrumb {
//     display: flex; align-items: center; gap: 8px;
//     padding: 0 28px 22px;
//     max-width: 1280px; margin: 0 auto;
//     font-size: 13.5px; color: var(--vd-text-muted);
//     flex-wrap: wrap;
//   }
//   .vd-back-link {
//     display: flex; align-items: center; gap: 4px;
//     color: var(--vd-teal); background: none; border: none;
//     cursor: pointer; font-size: 13.5px; font-weight: 600;
//     padding: 0; font-family: 'DM Sans', sans-serif;
//     transition: opacity 0.2s;
//   }
//   .vd-back-link:hover { opacity: 0.75; }
//   .vd-breadcrumb-sep { color: #cbd5e1; }
//   .vd-breadcrumb-current {
//     color: var(--vd-text-secondary); font-weight: 500;
//     white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
//     max-width: 260px;
//   }

//   /* ── LAYOUT ── */
//   .vd-layout {
//     display: flex; gap: 32px;
//     padding: 0 28px;
//     max-width: 1280px; margin: 0 auto;
//     align-items: flex-start;
//   }

//   .vd-main { flex: 1; min-width: 0; }

//   /* ── VIDEO PLAYER ── */
//   .vd-player-wrap {
//     position: relative; width: 100%;
//     aspect-ratio: 16/9;
//     background: #0d1117;
//     border-radius: 20px; overflow: hidden;
//     margin-bottom: 28px;
//     box-shadow: 0 8px 40px rgba(0,0,0,0.12);
//   }
//   .vd-thumb {
//     width: 100%; height: 100%; object-fit: cover; display: block;
//   }
//   .vd-play-overlay {
//     position: absolute; inset: 0;
//     background: linear-gradient(to top, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.1) 60%, transparent 100%);
//     display: flex; flex-direction: column;
//     align-items: center; justify-content: center;
//     cursor: pointer; gap: 14px;
//     transition: background 0.2s;
//   }
//   .vd-play-overlay:hover { background: linear-gradient(to top, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.2) 60%, transparent 100%); }
//   .vd-play-ripple {
//     position: absolute; width: 100px; height: 100px;
//     border-radius: 50%; border: 1.5px solid rgba(14,207,206,0.3);
//     animation: vdRipple 2s ease-in-out infinite; pointer-events: none;
//   }
//   @keyframes vdRipple {
//     0%,100% { transform: scale(1); opacity: 0.6; }
//     50% { transform: scale(1.4); opacity: 0; }
//   }
//   .vd-play-btn {
//     width: 72px; height: 72px; border-radius: 50%;
//     background: var(--vd-teal);
//     border: 3px solid rgba(255,255,255,0.25);
//     display: flex; align-items: center; justify-content: center;
//     cursor: pointer; position: relative; z-index: 2;
//     transition: transform 0.2s cubic-bezier(.22,.68,0,1.4), background 0.2s;
//     box-shadow: 0 6px 32px rgba(14,207,206,0.5);
//   }
//   .vd-play-btn:hover { transform: scale(1.1); background: var(--vd-teal-dark); }
//   .vd-play-btn svg { margin-left: 4px; }
//   .vd-play-hint {
//     font-size: 13px; color: rgba(255,255,255,0.7);
//     font-family: 'DM Sans', sans-serif; font-weight: 500;
//     position: relative; z-index: 2; margin: 0;
//   }

//   /* Badges on player */
//   .vd-badge {
//     position: absolute; top: 16px; left: 16px; z-index: 8;
//     display: inline-flex; align-items: center; gap: 5px;
//     font-size: 12px; font-weight: 700; padding: 5px 12px;
//     border-radius: 100px; backdrop-filter: blur(8px);
//     font-family: 'Plus Jakarta Sans', sans-serif; letter-spacing: 0.2px;
//   }
//   .vd-badge-preview { background: rgba(14,207,206,0.2); color: #fff; border: 1px solid rgba(14,207,206,0.45); }
//   .vd-badge-purchased { background: rgba(34,197,94,0.2); color: #fff; border: 1px solid rgba(34,197,94,0.45); }

//   /* Lock overlay */
//   .vd-lock-overlay {
//     position: absolute; inset: 0;
//     background: rgba(6,10,18,0.92); backdrop-filter: blur(8px);
//     display: flex; flex-direction: column;
//     align-items: center; justify-content: center;
//     gap: 12px; z-index: 10; padding: 28px;
//     text-align: center;
//     animation: vdLockIn 0.2s ease;
//   }
//   @keyframes vdLockIn { from { opacity: 0; transform: scale(0.98); } to { opacity: 1; transform: scale(1); } }
//   .vd-lock-ring {
//     position: absolute; width: 110px; height: 110px;
//     border-radius: 50%; border: 1.5px solid rgba(14,207,206,0.2);
//     animation: vdRipple 2s ease-in-out infinite; pointer-events: none;
//   }
//   .vd-lock-icon {
//     width: 70px; height: 70px; border-radius: 50%;
//     background: rgba(14,207,206,0.1); border: 1.5px solid rgba(14,207,206,0.3);
//     display: flex; align-items: center; justify-content: center;
//     position: relative; z-index: 1;
//   }
//   .vd-lock-title {
//     font-family: 'Plus Jakarta Sans', sans-serif; font-size: 20px;
//     font-weight: 800; color: #f1f5f9; margin: 4px 0 0; letter-spacing: -0.3px;
//   }
//   .vd-lock-sub { font-size: 13.5px; color: #64748b; margin: 0; max-width: 280px; line-height: 1.55; }
//   .vd-lock-actions { display: flex; gap: 10px; margin-top: 4px; }
//   .vd-btn-cart {
//     background:linear-gradient(135deg, #24aeb1, #058587); color: #fff; border: none;
//     border-radius: 12px; padding: 11px 26px;
//     font-size: 14px; font-weight: 700; cursor: pointer;
//     display: flex; align-items: center; gap: 8px;
//     transition: opacity 0.2s, transform 0.15s;
//     font-family: 'Plus Jakarta Sans', sans-serif;
//   }
//   .vd-btn-cart:hover:not(:disabled) { opacity: 0.87; transform: translateY(-1px); }
//   .vd-btn-cart.added { background: linear-gradient(135deg, #24aeb1, #058587); cursor: default; }
//   .vd-btn-cart:disabled { opacity: 0.7; }
//   .vd-btn-replay {
//     background: transparent; color: #475569;
//     border: 1px solid #2d3748; border-radius: 10px;
//     padding: 11px 20px; font-size: 13px; font-weight: 600;
//     cursor: pointer; display: flex; align-items: center; gap: 6px;
//     transition: color 0.2s, border-color 0.2s;
//     font-family: 'DM Sans', sans-serif;
//   }
//   .vd-btn-replay:hover { color: #94a3b8; border-color: #475569; }

//   .vd-no-video {
//     display: flex; flex-direction: column;
//     align-items: center; justify-content: center; gap: 12px;
//   }
//   .vd-no-video p { color: rgba(255,255,255,0.2); font-size: 13px; margin: 0; }
//   .vd-error {
//     width: 100%; height: 100%; display: flex; flex-direction: column;
//     align-items: center; justify-content: center; gap: 12px; padding: 20px;
//   }
//   .vd-error p { color: rgba(255,255,255,0.25); font-size: 13px; margin: 0; }
//   .vd-btn-retry {
//     background: rgba(14,207,206,0.12); color: var(--vd-teal);
//     border: 1px solid rgba(14,207,206,0.3); border-radius: 8px;
//     padding: 6px 16px; font-size: 12px; font-weight: 600;
//     cursor: pointer; font-family: 'DM Sans', sans-serif;
//     transition: background 0.2s;
//   }
//   .vd-btn-retry:hover { background: rgba(14,207,206,0.2); }

//   /* ── INFO BLOCK ── */
//   .vd-info-block { padding-bottom: 40px; }
//   .vd-title-row {
//     display: flex; align-items: flex-start;
//     justify-content: space-between; gap: 12px;
//     margin-bottom: 16px; flex-wrap: wrap;
//   }
//   .vd-title {
//     font-family: 'Plus Jakarta Sans', sans-serif;
//     font-size: clamp(1.45rem, 2.5vw, 2rem);
//     font-weight: 800; color: var(--vd-text-primary);
//     margin: 0; letter-spacing: -0.5px; line-height: 1.25;
//     flex: 1;
//   }
//   .vd-purchased-chip {
//     display: inline-flex; align-items: center; gap: 5px;
//     background: #f0fdf4; color: var(--vd-green-dark);
//     border: 1px solid #bbf7d0; border-radius: 100px;
//     font-size: 12px; font-weight: 700; padding: 5px 12px;
//     font-family: 'Plus Jakarta Sans', sans-serif;
//     white-space: nowrap; flex-shrink: 0;
//   }

//   /* Mobile CTA (hidden on desktop) */
//   .vd-mobile-cta {
//     display: none; align-items: center; justify-content: space-between;
//     gap: 12px; padding: 16px 0; border-bottom: 1px solid #f1f5f9;
//     margin-bottom: 20px;
//   }

//   .vd-price-row { display: flex; align-items: baseline; gap: 8px; }
//   .vd-price-current {
//     font-family: 'Plus Jakarta Sans', sans-serif;
//     font-size: 26px; font-weight: 800; color: var(--vd-green); letter-spacing: -0.6px;
//   }
//   .vd-price-old { font-size: 14px; color: var(--vd-text-muted); text-decoration: line-through; font-weight: 500; }
//   .vd-price-free { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 22px; font-weight: 800; color: var(--vd-teal); }

//   .vd-btn-add-mobile {
//     padding: 10px 20px; border-radius: 10px;
//     border: 1.5px solid var(--vd-teal); background: transparent;
//     color: var(--vd-teal); font-size: 13.5px; font-weight: 700;
//     cursor: pointer; display: flex; align-items: center; gap: 6px;
//     transition: background 0.2s, color 0.2s;
//     font-family: 'Plus Jakarta Sans', sans-serif; white-space: nowrap;
//   }
//   .vd-btn-add-mobile:hover:not(:disabled):not(.added) { background: var(--vd-teal); color: #fff; }
//   .vd-btn-add-mobile.added { background: #f0fdf4; border-color: var(--vd-green); color: var(--vd-green-dark); cursor: default; }

//   /* ── CONTENT SECTIONS ── */
//   .vd-tabs-section { display: flex; flex-direction: column; gap: 28px; }
//   .vd-section {
//     background: var(--vd-card-bg); border: 1.5px solid var(--vd-border);
//     border-radius: 16px; padding: 24px 26px;
//     animation: vdFadeUp 0.4s ease both;
//   }
//   @keyframes vdFadeUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
//   .vd-section-title {
//     font-family: 'Plus Jakarta Sans', sans-serif;
//     font-size: 15px; font-weight: 700; color: var(--vd-text-primary);
//     margin: 0 0 16px; display: flex; align-items: center; gap: 8px;
//     padding-bottom: 12px; border-bottom: 1px solid #f1f5f9;
//   }
//   .vd-section-title svg { color: var(--vd-teal); flex-shrink: 0; }

//   /* HTML content inside sections */
//   .vd-html-content p { font-size: 14.5px; color: var(--vd-text-secondary); line-height: 1.75; margin: 0 0 8px; }
//   .vd-html-content ul, .vd-html-content ol {
//     padding-left: 22px; margin: 6px 0;
//   }
//   .vd-html-content li {
//     font-size: 14.5px; color: var(--vd-text-secondary);
//     line-height: 1.7; margin-bottom: 5px; list-style-type: disc;
//   }
//   .vd-html-content ol li { list-style-type: decimal; }
//   .vd-html-content strong { color: var(--vd-text-primary); font-weight: 700; }
//   .vd-html-content a { color: var(--vd-teal); text-decoration: none; }

//   .vd-learn-list .vd-html-content li {
//     list-style: none; padding-left: 24px; position: relative;
//   }
//   .vd-learn-list .vd-html-content li::before {
//     content: ""; position: absolute; left: 0; top: 8px;
//     width: 8px; height: 8px; border-radius: 50%; background: var(--vd-teal);
//   }

//   /* ── SIDEBAR ── */
//   .vd-sidebar {
//     width: var(--vd-sidebar-w);
//     flex-shrink: 0;
//     position: sticky; top: 24px;
//     display: flex; flex-direction: column; gap: 20px;
//   }
//   .vd-sidebar-card {
//     background: var(--vd-card-bg); border: 1.5px solid var(--vd-border);
//     border-radius: 20px; overflow: hidden;
//     box-shadow: 0 4px 24px rgba(0,0,0,0.05);
//     animation: vdFadeUp 0.4s ease both;
//   }
//   .vd-sidebar-thumb {
//     width: 100%; height: 185px; overflow: hidden; position: relative;
//     background: #0d1117;
//   }
//   .vd-sidebar-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
//   .vd-sidebar-thumb-overlay {
//     position: absolute; inset: 0;
//     background: rgba(0,0,0,0.3);
//     display: flex; align-items: center; justify-content: center;
//   }
//   .vd-sidebar-thumb-overlay svg { opacity: 0.7; }

//   .vd-sidebar-price-row {
//     padding: 18px 20px 0;
//     display: flex; align-items: baseline; gap: 10px; flex-wrap: wrap;
//   }
//   .vd-sidebar-price-current {
//     font-family: 'Plus Jakarta Sans', sans-serif;
//     font-size: 28px; font-weight: 800; color: var(--vd-green); letter-spacing: -0.7px;
//   }
//   .vd-sidebar-price-old {
//     font-size: 14px; color: var(--vd-text-muted); text-decoration: line-through;
//   }
//   .vd-sidebar-price-free {
//     font-family: 'Plus Jakarta Sans', sans-serif;
//     font-size: 22px; font-weight: 800; color: var(--vd-teal);
//   }
//   .vd-discount-chip {
//     background: #fef3c7; color: #d97706;
//     font-size: 11.5px; font-weight: 700; padding: 3px 9px;
//     border-radius: 100px; font-family: 'Plus Jakarta Sans', sans-serif;
//     border: 1px solid #fde68a;
//   }

//   .vd-cta-stack { padding: 14px 20px 16px; display: flex; flex-direction: column; gap: 10px; }
//   .vd-btn-addcart {
//     width: 100%; padding: 13px 0; border-radius: 12px;
//     border: 1.5px solid var(--vd-teal); background: transparent;
//     color: var(--vd-teal); font-size: 14.5px; font-weight: 700;
//     cursor: pointer; display: flex; align-items: center; justify-content: center;
//     gap: 8px; transition: background 0.2s, color 0.2s, transform 0.15s;
//     font-family: 'Plus Jakarta Sans', sans-serif;
//   }
//   .vd-btn-addcart:hover:not(:disabled):not(.added) {
//     background: var(--vd-teal); color: #fff; transform: translateY(-1px);
//   }
//   .vd-btn-addcart.added {
//     background: #f0fdf4; border-color: var(--vd-green); color: var(--vd-green-dark); cursor: default;
//   }
//   .vd-btn-addcart:disabled:not(.added) { opacity: 0.65; cursor: not-allowed; }

//   .vd-owned-block { padding: 14px 20px 16px; }
//   .vd-owned-badge {
//     display: flex; align-items: center; gap: 7px;
//     background: #f0fdf4; color: var(--vd-green-dark);
//     border: 1px solid #bbf7d0; border-radius: 10px;
//     padding: 10px 14px; font-size: 13.5px; font-weight: 700;
//     font-family: 'Plus Jakarta Sans', sans-serif; margin-bottom: 8px;
//   }
//   .vd-owned-sub { font-size: 12.5px; color: var(--vd-text-muted); margin: 0; padding: 0 2px; }

//   .vd-no-purchase {
//     display: flex; align-items: center; gap: 6px;
//     color: var(--vd-text-muted); font-size: 13px;
//     padding: 14px 20px 16px;
//   }

//   .vd-perks {
//     list-style: none; margin: 0; padding: 14px 20px 20px;
//     border-top: 1px solid #f1f5f9;
//     display: flex; flex-direction: column; gap: 9px;
//   }
//   .vd-perks li {
//     display: flex; align-items: center; gap: 8px;
//     font-size: 13px; color: var(--vd-text-secondary);
//     font-family: 'DM Sans', sans-serif;
//   }

//   /* ── RELATED ── */
//   .vd-related { background: var(--vd-card-bg); border: 1.5px solid var(--vd-border); border-radius: 20px; overflow: hidden; }
//   .vd-related-title {
//     font-family: 'Plus Jakarta Sans', sans-serif; font-size: 14px; font-weight: 700;
//     color: var(--vd-text-primary); padding: 16px 18px 12px;
//     border-bottom: 1px solid #f1f5f9; margin: 0;
//   }
//   .vd-related-list { padding: 8px 0; }
//   .vd-related-item {
//     display: flex; gap: 12px; padding: 10px 16px;
//     cursor: pointer; transition: background 0.15s; align-items: center;
//   }
//   .vd-related-item:hover { background: #f8fffe; }
//   .vd-related-thumb {
//     width: 76px; height: 50px; border-radius: 8px;
//     overflow: hidden; flex-shrink: 0; background: #0d1117;
//     position: relative;
//   }
//   .vd-related-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
//   .vd-related-no-thumb {
//     width: 100%; height: 100%; display: flex;
//     align-items: center; justify-content: center;
//   }
//   .vd-related-play {
//     position: absolute; inset: 0;
//     background: rgba(0,0,0,0.3);
//     display: flex; align-items: center; justify-content: center;
//   }
//   .vd-related-info { flex: 1; min-width: 0; }
//   .vd-related-name {
//     font-size: 13px; font-weight: 600; color: var(--vd-text-primary);
//     margin: 0 0 4px; line-height: 1.35;
//     white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
//     font-family: 'Plus Jakarta Sans', sans-serif;
//   }
//   .vd-related-price { font-size: 12.5px; font-weight: 700; color: var(--vd-green); margin: 0; }

//   /* ── SPINNER ── */
//   .vd-spinner {
//     display: inline-block; width: 16px; height: 16px;
//     border: 2px solid rgba(255,255,255,0.3); border-top-color: #fff;
//     border-radius: 50%; animation: vdSpin 0.7s linear infinite;
//   }
//   .vd-spinner-teal { border-color: rgba(14,207,206,0.3); border-top-color: var(--vd-teal); }
//   @keyframes vdSpin { to { transform: rotate(360deg); } }

//   /* ── SKELETON ── */
//   .vd-skeleton-wrap { max-width: 900px; margin: 0 auto; padding: 0 28px; }
//   .vd-skeleton {
//     background: linear-gradient(90deg, #f8fafc 25%, #f1f5f9 50%, #f8fafc 75%);
//     background-size: 200% 100%; animation: vdSkel 1.5s ease-in-out infinite;
//   }
//   @keyframes vdSkel { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }

//   /* ── NOT FOUND ── */
//   .vd-not-found {
//     text-align: center; padding: 80px 20px;
//     display: flex; flex-direction: column; align-items: center; gap: 12px;
//   }
//   .vd-not-found h2 { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 24px; font-weight: 800; color: var(--vd-text-primary); margin: 0; }
//   .vd-not-found p { color: var(--vd-text-muted); margin: 0; font-size: 15px; }
//   .vd-back-btn {
//     background: var(--vd-teal); color: #fff; border: none; border-radius: 10px;
//     padding: 10px 22px; font-size: 14px; font-weight: 700; cursor: pointer;
//     font-family: 'Plus Jakarta Sans', sans-serif; margin-top: 8px;
//     transition: opacity 0.2s;
//   }
//   .vd-back-btn:hover { opacity: 0.87; }

//   /* ── RESPONSIVE ── */
//   @media (max-width: 1024px) {
//     :root { --vd-sidebar-w: 290px; }
//   }

//   @media (max-width: 820px) {
//     .vd-layout { flex-direction: column; }
//     .vd-sidebar { width: 100%; position: static; }
//     .vd-mobile-cta { display: flex; }
//     .vd-sidebar-card .vd-cta-stack,
//     .vd-sidebar-card .vd-owned-block { display: none; }
//     .vd-player-wrap { border-radius: 14px; }
//     .vd-layout { padding: 0 16px; }
//     .vd-breadcrumb { padding: 0 16px 18px; }
//   }

//   @media (max-width: 480px) {
//     .vd-root { padding: 16px 0 60px; }
//     .vd-title { font-size: 1.35rem; }
//     .vd-lock-actions { flex-direction: column; width: 100%; }
//     .vd-btn-cart, .vd-btn-replay { width: 100%; justify-content: center; }
//   }
// `;

// export default CourseSectionDetailPage;


// Before Claude 20march
// import React, { useEffect, useState, useRef } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import Layout from "../../Layout/Layout";
// import FooterNew from "../../Layout/FooterNew";

// // ✅ Same API as the list page
// const API_URL = "https://ecom.cyberathon.com/index.php/Api/list_get_product";
// const BASE_URL = "https://ecom.cyberathon.com/";
// const FREE_SECONDS = 10;

// // ─── Helpers ─────────────────────────────────────────────────────────────────
// function detectVideoType(url) {
//   if (!url || url.trim() === "") return "no-video";
//   const u = url.toLowerCase();
//   if (u.includes("youtube.com") || u.includes("youtu.be")) return "youtube";
//   if (
//     u.endsWith(".mp4") || u.endsWith(".webm") || u.endsWith(".ogg") ||
//     u.includes(".mp4?") || u.includes("gtv-videos-bucket") ||
//     u.includes("commondatastorage.googleapis.com") || u.includes("archive.org")
//   ) return "mp4";
//   if (u.includes("vimeo.com") || u.includes("dailymotion.com")) return "iframe";
//   return "mp4";
// }

// function buildYouTubeEmbedUrl(raw) {
//   try {
//     if (raw.includes("watch?v=")) {
//       const id = new URLSearchParams(new URL(raw).search).get("v");
//       return `https://www.youtube.com/embed/${id}`;
//     }
//     if (raw.includes("youtu.be/")) return `https://www.youtube.com/embed/${raw.split("youtu.be/")[1].split("?")[0]}`;
//     if (raw.includes("embed/")) return raw;
//   } catch (e) {}
//   return raw;
// }

// function getYouTubeId(embedUrl) {
//   if (!embedUrl) return "";
//   const match = embedUrl.match(/embed\/([^?&]+)/);
//   return match ? match[1] : "";
// }

// function loadYouTubeAPI() {
//   if (window.YT && window.YT.Player) return Promise.resolve();
//   if (window.__ytApiPromise) return window.__ytApiPromise;
//   window.__ytApiPromise = new Promise((resolve) => {
//     window.onYouTubeIframeAPIReady = resolve;
//     const tag = document.createElement("script");
//     tag.src = "https://www.youtube.com/iframe_api";
//     document.body.appendChild(tag);
//   });
//   return window.__ytApiPromise;
// }

// const HtmlContent = ({ html, className = "" }) => {
//   if (!html) return null;
//   return <div className={className} dangerouslySetInnerHTML={{ __html: html }} />;
// };

// async function addToCartApi(prod_id, onSuccess, onError) {
//   const userId = sessionStorage.getItem("userId");
//   if (!userId) { 
//     // alert("Please login first!"); 
//     sessionStorage.setItem("redirectAfterLogin", window.location.pathname);
//      window.dispatchEvent(new Event("openLoginModal"));
//     return;
//    }
//   try {
//     const res = await axios.post(
//       "https://ecom.cyberathon.com/index.php/Api/insert_cart",
//       { user_id: Number(userId), prod_id: Number(prod_id), qty: 1 }
//     );
//     if (res.data.status === true) onSuccess();
//     else onError(res.data.message || "Failed to add");
//   } catch (e) { onError("Something went wrong"); }
// }

// // ─── Map raw API product → unified video object ───────────────────────────────
// function mapProduct(p) {
//   let rawUrl = p.video || p.video_url || p.product_video || "";
//   if (rawUrl && !rawUrl.startsWith("http")) rawUrl = BASE_URL + rawUrl;

//   const type = detectVideoType(rawUrl);
//   let embedUrl = rawUrl;
//   if (type === "youtube") embedUrl = buildYouTubeEmbedUrl(rawUrl);

//   return {
//     id: p.id || p.ref_id,
//     prod_id: p.prod_id,
//     heading: p.heading || p.product_name || p.title || "Untitled Course",
//     description: p.description || "",
//     details: p.details || "",
//     current_price: p.current_price || 0,
//     old_price: p.old_price || 0,
//     type,
//     embedUrl,
//   };
// }

// // ─── Video Player Section ─────────────────────────────────────────────────────
// const VideoPlayer = ({ video, isPurchased, isAdded, onAddedChange }) => {
//   const [phase, setPhase] = useState("idle");
//   const videoRef = useRef(null);
//   const timerRef = useRef(null);
//   const playerRef = useRef(null);
//   const [loading, setLoading] = useState(false);
//   const divId = `detail-yt-${video.prod_id}`;

//   const videoId = video.type === "youtube" ? getYouTubeId(video.embedUrl) : null;
//   const thumbUrl = videoId ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg` : null;

//   useEffect(() => {
//     if (phase !== "playing" || video.type !== "mp4") return;
//     const vid = videoRef.current;
//     if (!vid || isPurchased) return;
//     const onPlay = () => {
//       timerRef.current = setTimeout(() => { vid.pause(); setPhase("locked"); }, FREE_SECONDS * 1000);
//     };
//     vid.addEventListener("play", onPlay);
//     return () => { vid.removeEventListener("play", onPlay); clearTimeout(timerRef.current); };
//   }, [phase, isPurchased, video.type]);

//   const handlePlay = async () => {
//     if (video.type === "youtube") {
//       setPhase("playing");
//       await loadYouTubeAPI();
//       setTimeout(() => {
//         playerRef.current = new window.YT.Player(divId, {
//           events: {
//             onReady: (e) => {
//               e.target.playVideo();
//               if (!isPurchased) {
//                 timerRef.current = setTimeout(() => {
//                   e.target.pauseVideo();
//                   setPhase("locked");
//                 }, FREE_SECONDS * 1000);
//               }
//             },
//           },
//         });
//       }, 300);
//     } else {
//       setPhase("playing");
//     }
//   };

//   const handleReplay = () => {
//     clearTimeout(timerRef.current);
//     if (playerRef.current) { try { playerRef.current.destroy(); } catch (e) {} playerRef.current = null; }
//     setPhase("idle");
//   };

//   useEffect(() => () => {
//     clearTimeout(timerRef.current);
//     if (playerRef.current) { try { playerRef.current.destroy(); } catch (e) {} }
//   }, []);

//   const handleCartFromLock = async () => {
//     setLoading(true);
//     await addToCartApi(
//       video.prod_id,
//       () => { onAddedChange(true); setLoading(false); },
//       (msg) => { alert(msg); setLoading(false); }
//     );
//   };

//   if (video.type === "no-video") {
//     return (
//       <div className="vd-player-wrap vd-no-video">
//         <svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1.2">
//           <rect x="2" y="2" width="20" height="20" rx="2.5" />
//           <path d="M10 8l6 4-6 4V8z" />
//           <line x1="2" y1="2" x2="22" y2="22" />
//         </svg>
//         <p>No video available for this course</p>
//       </div>
//     );
//   }

//   return (
//     <div className="vd-player-wrap">
//       {isPurchased ? (
//         <span className="vd-badge vd-badge-purchased">
//           <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
//           Full Access Unlocked
//         </span>
//       ) : (
//         <span className="vd-badge vd-badge-preview">
//           <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21" /></svg>
//           {FREE_SECONDS}s Free Preview
//         </span>
//       )}

//       {phase === "idle" && (
//         <>
//           {video.type === "youtube" && thumbUrl ? (
//             <img src={thumbUrl} alt={video.heading} className="vd-thumb" />
//           ) : video.type === "mp4" ? (
//             <video src={`${video.embedUrl}#t=0.5`} className="vd-thumb" preload="metadata" muted playsInline />
//           ) : (
//             <div className="vd-thumb" style={{ background: "#0d1117" }} />
//           )}
//           <div className="vd-play-overlay" onClick={handlePlay}>
//             <div className="vd-play-ripple" />
//             <button className="vd-play-btn">
//               <svg width="28" height="28" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21" /></svg>
//             </button>
//             <p className="vd-play-hint">Click to play {isPurchased ? "full video" : "free preview"}</p>
//           </div>
//         </>
//       )}

//       {phase === "playing" && (
//         <>
//           {video.type === "youtube" && (
//             <iframe
//               id={divId}
//               src={`https://www.youtube.com/embed/${videoId}?enablejsapi=1`}
//               title={video.heading}
//               allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
//               allowFullScreen
//               style={{ width: "100%", height: "100%", border: "none", display: "block" }}
//             />
//           )}
//           {video.type === "mp4" && (
//             <video
//               ref={videoRef}
//               src={video.embedUrl}
//               controls={isPurchased}
//               autoPlay
//               playsInline
//               onError={() => setPhase("error")}
//               style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
//             />
//           )}
//           {video.type === "iframe" && (
//             <iframe
//               src={video.embedUrl}
//               title={video.heading}
//               allow="autoplay; fullscreen"
//               allowFullScreen
//               style={{ width: "100%", height: "100%", border: "none", display: "block" }}
//             />
//           )}
//         </>
//       )}

//       {phase === "locked" && (
//         <>
//           {video.type === "youtube" && thumbUrl && (
//             <img src={thumbUrl} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", filter: "blur(8px) brightness(0.3)" }} />
//           )}
//           <div className="vd-lock-overlay">
//             <div className="vd-lock-ring" />
//             <div className="vd-lock-icon">
//               <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <rect x="3" y="11" width="18" height="11" rx="2" />
//                 <path d="M7 11V7a5 5 0 0 1 10 0v4" />
//               </svg>
//             </div>
//             <h3 className="vd-lock-title">Preview Ended</h3>
//             <p className="vd-lock-sub">Purchase this course to watch the full video</p>
//             <div className="vd-lock-actions">
//               {video.prod_id && (
//                 <button
//                   className={`vd-btn-cart${isAdded ? " added" : ""}`}
//                   onClick={handleCartFromLock}
//                   disabled={loading || isAdded}
//                 >
//                   {loading ? <span className="vd-spinner" /> :
//                     isAdded ? (
//                       <><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg> Added to Cart</>
//                     ) : (
//                       <><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" /></svg> Add to Cart</>
//                     )}
//                 </button>
//               )}
//               <button className="vd-btn-replay" onClick={handleReplay}>
//                 <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="1 4 1 10 7 10" /><path d="M3.51 15a9 9 0 1 0 .49-6" /></svg>
//                 Replay Preview
//               </button>
//             </div>
//           </div>
//         </>
//       )}

//       {phase === "error" && (
//         <div className="vd-error">
//           <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="1.5"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
//           <p>Video could not be loaded</p>
//           <button className="vd-btn-retry" onClick={() => setPhase("idle")}>Try Again</button>
//         </div>
//       )}
//     </div>
//   );
// };

// // ─── MAIN DETAIL PAGE ─────────────────────────────────────────────────────────
// const CourseSectionDetailPage = () => {
//   // ✅ Route must be: /coursesectiondetail/:id  where :id = prod_id
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [video, setVideo] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isPurchased, setIsPurchased] = useState(false);
//   const [isAdded, setIsAdded] = useState(false);
//   const [cartLoading, setCartLoading] = useState(false);
//   const [relatedVideos, setRelatedVideos] = useState([]);

//   useEffect(() => {
//     const load = async () => {
//       try {
//         const res = await axios.get(API_URL);

//         if (!res.data?.status) { setLoading(false); return; }

//         const products = Array.isArray(res.data.products) ? res.data.products : [];

//         // ✅ Filter only coursesection type and map to unified shape
//         const all = products
//           .filter((p) => p.product_type && p.product_type.toLowerCase() === "coursesection")
//           .map(mapProduct);

//         // ✅ Find by prod_id (URL param :id = prod_id)
//         const found = all.find((v) => String(v.prod_id) === String(id));
//         setVideo(found || null);

//         // ✅ Related = other courses (exclude current)
//         setRelatedVideos(all.filter((v) => String(v.prod_id) !== String(id)).slice(0, 4));

//         if (!found) { setLoading(false); return; }

//         // Check cart & purchased status
//         const userId = sessionStorage.getItem("userId");
//         const cartToken = localStorage.getItem("cart_token");

//         if (userId || cartToken) {
//           try {
//             const cr = await axios.post("https://ecom.cyberathon.com/index.php/Api/list_cart", {
//               user_id: userId || null,
//               cart_token: userId ? null : cartToken,
//             });
//             if (cr.data.status) {
//               const inCart = cr.data.cart_items.some((i) => String(i.prod_id) === String(found.prod_id));
//               setIsAdded(inCart);
//             }
//           } catch (e) {}
//         }

//         if (userId) {
//           try {
//             const or = await axios.post("https://ecom.cyberathon.com/index.php/Api/list_new_order", {
//               user_id: parseInt(userId),
//             });
//             if (or.data.status && Array.isArray(or.data.orders)) {
//               const purchased = or.data.orders.some((order) =>
//                 Array.isArray(order.items) &&
//                 order.items.some((item) => {
//                   if (String(item.prod_id) !== String(found.prod_id)) return false;
//                   return (
//                     item.access === "unlocked" ||
//                     order.purchase_status === "yes" ||
//                     order.payment_status === "Paid" ||
//                     order.payment_status === "paid" ||
//                     order.order_status === "Delivered" ||
//                     order.order_status === "Completed"
//                   );
//                 })
//               );
//               setIsPurchased(purchased);
//             }
//           } catch (e) {}
//         }
//       } catch (e) {
//         console.error(e);
//       } finally {
//         setLoading(false);
//       }
//     };

//     load();
//     window.scrollTo(0, 0);
//   }, [id]);

//   const handleAddToCart = async () => {
//     if (isAdded || !video?.prod_id) return;
//     setCartLoading(true);
//     await addToCartApi(
//       video.prod_id,
//       () => { setIsAdded(true); setCartLoading(false); },
//       (msg) => { alert(msg); setCartLoading(false); }
//     );
//   };

//   if (loading) {
//     return (
//       <>
//         <style>{detailStyles}</style>
//         <div className="vd-root">
//           <div className="vd-skeleton-wrap">
//             <div className="vd-skeleton" style={{ height: 480, borderRadius: 20, marginBottom: 32 }} />
//             <div className="vd-skeleton" style={{ height: 28, width: "60%", marginBottom: 16 }} />
//             <div className="vd-skeleton" style={{ height: 16, width: "80%", marginBottom: 10 }} />
//             <div className="vd-skeleton" style={{ height: 16, width: "70%" }} />
//           </div>
//         </div>
//       </>
//     );
//   }

//   if (!video) {
//     return (
//       <>
//         <style>{detailStyles}</style>
//         <div className="vd-root">
//           <div className="vd-not-found">
//             <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.2"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
//             <h2>Course Not Found</h2>
//             <p>This course doesn't exist or has been removed.</p>
//             <button className="vd-back-btn" onClick={() => navigate(-1)}>← Go Back</button>
//           </div>
//         </div>
//       </>
//     );
//   }

//   const hasPaid = video.current_price && Number(video.current_price) > 0;

//   return (
//     <>
//       <Layout />
//       <style>{detailStyles}</style>
//       <div className="vd-root">

//         <div className="vd-breadcrumb">
//           <button onClick={() => navigate(-1)} className="vd-back-link">
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="15 18 9 12 15 6" /></svg>
//             Back to Courses
//           </button>
//           <span className="vd-breadcrumb-sep">/</span>
//           <span className="vd-breadcrumb-current">{video.heading}</span>
//         </div>

//         <div className="vd-layout">
//           <div className="vd-main">
//             <VideoPlayer
//               video={video}
//               isPurchased={isPurchased}
//               isAdded={isAdded}
//               onAddedChange={setIsAdded}
//             />

//             <div className="vd-info-block">
//               <div className="vd-title-row">
//                 <h1 className="vd-title">{video.heading}</h1>
//                 {isPurchased && (
//                   <span className="vd-purchased-chip">
//                     <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>
//                     Purchased
//                   </span>
//                 )}
//               </div>

//               <div className="vd-mobile-cta">
//                 <div className="vd-price-row">
//                   {hasPaid ? (
//                     <>
//                       <span className="vd-price-current">₹{Number(video.current_price).toLocaleString("en-IN")}</span>
//                       {video.old_price && Number(video.old_price) > 0 && (
//                         <span className="vd-price-old">₹{Number(video.old_price).toLocaleString("en-IN")}</span>
//                       )}
//                     </>
//                   ) : (
//                     <span className="vd-price-free">Free</span>
//                   )}
//                 </div>
//                 {video.prod_id && !isPurchased && (
//                   <button
//                     className={`vd-btn-add-mobile${isAdded ? " added" : ""}`}
//                     onClick={handleAddToCart}
//                     disabled={cartLoading || isAdded}
//                   >
//                     {cartLoading ? <span className="vd-spinner" /> :
//                       isAdded ? <><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg> Added</> :
//                       <><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" /></svg> Add to Cart</>
//                     }
//                   </button>
//                 )}
//               </div>

//               <div className="vd-tabs-section">
//                 {video.description && (
//                   <div className="vd-section">
//                     <h3 className="vd-section-title">
//                       <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
//                       About This Course
//                     </h3>
//                     <div className="vd-html-content">
//                       <HtmlContent html={video.description} />
//                     </div>
//                   </div>
//                 )}

//                 {video.details && (
//                   <div className="vd-section">
//                     <h3 className="vd-section-title">
//                       <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 11 12 14 22 4" /><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" /></svg>
//                       What You'll Learn
//                     </h3>
//                     <div className="vd-html-content vd-learn-list">
//                       <HtmlContent html={video.details} />
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* RIGHT — Sticky Sidebar */}
//           <div className="vd-sidebar">
//             <div className="vd-sidebar-card">
//               <div className="vd-sidebar-thumb">
//                 {video.type === "youtube" && getYouTubeId(video.embedUrl) ? (
//                   <img src={`https://img.youtube.com/vi/${getYouTubeId(video.embedUrl)}/hqdefault.jpg`} alt={video.heading} />
//                 ) : video.type === "mp4" ? (
//                   <video src={`${video.embedUrl}#t=0.5`} muted playsInline preload="metadata" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//                 ) : (
//                   <div style={{ width: "100%", height: "100%", background: "linear-gradient(135deg,#0d1117,#1a2332)", display: "flex", alignItems: "center", justifyContent: "center" }}>
//                     <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1.2"><rect x="2" y="2" width="20" height="20" rx="2.5" /><path d="M10 8l6 4-6 4V8z" /></svg>
//                   </div>
//                 )}
//                 <div className="vd-sidebar-thumb-overlay">
//                   <svg width="22" height="22" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21" /></svg>
//                 </div>
//               </div>

//               <div className="vd-sidebar-price-row">
//                 {hasPaid ? (
//                   <>
//                     <span className="vd-sidebar-price-current">₹{Number(video.current_price).toLocaleString("en-IN")}</span>
//                     {video.old_price && Number(video.old_price) > 0 && (
//                       <span className="vd-sidebar-price-old">₹{Number(video.old_price).toLocaleString("en-IN")}</span>
//                     )}
//                   </>
//                 ) : (
//                   <span className="vd-sidebar-price-free">Free</span>
//                 )}
//               </div>

//               {!video.prod_id ? (
//                 <div className="vd-no-purchase">
//                   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
//                   Not available for purchase
//                 </div>
//               ) : isPurchased ? (
//                 <div className="vd-owned-block">
//                   <div className="vd-owned-badge">
//                     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>
//                     You own this course
//                   </div>
//                   <p className="vd-owned-sub">You have full lifetime access</p>
//                 </div>
//               ) : (
//                 <div className="vd-cta-stack">
//                   <button
//                     className={`vd-btn-addcart${isAdded ? " added" : ""}`}
//                     onClick={handleAddToCart}
//                     disabled={cartLoading || isAdded}
//                   >
//                     {cartLoading ? (
//                       <span className="vd-spinner vd-spinner-teal" />
//                     ) : isAdded ? (
//                       <><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg> Added to Cart</>
//                     ) : (
//                       <><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" /></svg> Add to Cart</>
//                     )}
//                   </button>
//                 </div>
//               )}

//               <ul className="vd-perks">
//                 <li><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2"><polyline points="20 6 9 17 4 12" /></svg>Lifetime access after purchase</li>
//                 <li><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2"><polyline points="20 6 9 17 4 12" /></svg>Watch on any device</li>
//                 <li><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2"><polyline points="20 6 9 17 4 12" /></svg>Free {FREE_SECONDS}s preview available</li>
//               </ul>
//             </div>

//             {/* Related Videos */}
//             {relatedVideos.length > 0 && (
//               <div className="vd-related">
//                 <h3 className="vd-related-title">More Courses</h3>
//                 <div className="vd-related-list">
//                   {relatedVideos.map((rv) => {
//                     const rvId = rv.type === "youtube" ? getYouTubeId(rv.embedUrl) : null;
//                     return (
//                       <div
//                         key={rv.prod_id}
//                         className="vd-related-item"
//                         // ✅ Navigate using prod_id
//                         onClick={() => navigate(`/coursesectiondetail/${rv.prod_id}`)}
//                       >
//                         <div className="vd-related-thumb">
//                           {rvId ? (
//                             <img src={`https://img.youtube.com/vi/${rvId}/hqdefault.jpg`} alt={rv.heading} />
//                           ) : rv.type === "mp4" ? (
//                             <video src={`${rv.embedUrl}#t=0.5`} muted playsInline preload="metadata" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//                           ) : (
//                             <div className="vd-related-no-thumb">
//                               <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1.5"><rect x="2" y="2" width="20" height="20" rx="2" /><path d="M10 8l6 4-6 4V8z" /></svg>
//                             </div>
//                           )}
//                           <div className="vd-related-play">
//                             <svg width="10" height="10" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21" /></svg>
//                           </div>
//                         </div>
//                         <div className="vd-related-info">
//                           <p className="vd-related-name">{rv.heading}</p>
//                           <p className="vd-related-price">
//                             {rv.current_price && Number(rv.current_price) > 0
//                               ? `₹${Number(rv.current_price).toLocaleString("en-IN")}`
//                               : "Free"}
//                           </p>
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//       <FooterNew />
//     </>
//   );
// };

// // ─── STYLES ──────────────────────────────────────────────────────────────────
// const detailStyles = `
//   @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=DM+Sans:ital,wght@0,400;0,500;0,600;1,400&display=swap');

//   :root {
//     --vd-teal: #0ecfce;
//     --vd-teal-dark: #0ab5b4;
//     --vd-green: #22c55e;
//     --vd-green-dark: #16a34a;
//     --vd-text-primary: #0f172a;
//     --vd-text-secondary: #475569;
//     --vd-text-muted: #94a3b8;
//     --vd-surface: #f7fffe;
//     --vd-card-bg: #ffffff;
//     --vd-border: #e5f0f0;
//     --vd-sidebar-w: 340px;
//   }

//   .vd-root { background: var(--vd-surface); min-height: 100vh; padding: 28px 0 80px; font-family: 'DM Sans', sans-serif; }

//   .vd-breadcrumb { display: flex; align-items: center; gap: 8px; padding: 0 28px 22px; max-width: 1280px; margin: 0 auto; font-size: 13.5px; color: var(--vd-text-muted); flex-wrap: wrap; }
//   .vd-back-link { display: flex; align-items: center; gap: 4px; color: var(--vd-teal); background: none; border: none; cursor: pointer; font-size: 13.5px; font-weight: 600; padding: 0; font-family: 'DM Sans', sans-serif; transition: opacity 0.2s; }
//   .vd-back-link:hover { opacity: 0.75; }
//   .vd-breadcrumb-sep { color: #cbd5e1; }
//   .vd-breadcrumb-current { color: var(--vd-text-secondary); font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 260px; }

//   .vd-layout { display: flex; gap: 32px; padding: 0 28px; max-width: 1280px; margin: 0 auto; align-items: flex-start; }
//   .vd-main { flex: 1; min-width: 0; }

//   .vd-player-wrap { position: relative; width: 100%; aspect-ratio: 16/9; background: #0d1117; border-radius: 20px; overflow: hidden; margin-bottom: 28px; box-shadow: 0 8px 40px rgba(0,0,0,0.12); }
//   .vd-thumb { width: 100%; height: 100%; object-fit: cover; display: block; }
//   .vd-play-overlay { position: absolute; inset: 0; background: linear-gradient(to top, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.1) 60%, transparent 100%); display: flex; flex-direction: column; align-items: center; justify-content: center; cursor: pointer; gap: 14px; transition: background 0.2s; }
//   .vd-play-overlay:hover { background: linear-gradient(to top, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.2) 60%, transparent 100%); }
//   .vd-play-ripple { position: absolute; width: 100px; height: 100px; border-radius: 50%; border: 1.5px solid rgba(14,207,206,0.3); animation: vdRipple 2s ease-in-out infinite; pointer-events: none; }
//   @keyframes vdRipple { 0%,100% { transform: scale(1); opacity: 0.6; } 50% { transform: scale(1.4); opacity: 0; } }
//   .vd-play-btn { width: 72px; height: 72px; border-radius: 50%; background: var(--vd-teal); border: 3px solid rgba(255,255,255,0.25); display: flex; align-items: center; justify-content: center; cursor: pointer; position: relative; z-index: 2; transition: transform 0.2s cubic-bezier(.22,.68,0,1.4), background 0.2s; box-shadow: 0 6px 32px rgba(14,207,206,0.5); }
//   .vd-play-btn:hover { transform: scale(1.1); background: var(--vd-teal-dark); }
//   .vd-play-btn svg { margin-left: 4px; }
//   .vd-play-hint { font-size: 13px; color: rgba(255,255,255,0.7); font-family: 'DM Sans', sans-serif; font-weight: 500; position: relative; z-index: 2; margin: 0; }

//   .vd-badge { position: absolute; top: 16px; left: 16px; z-index: 8; display: inline-flex; align-items: center; gap: 5px; font-size: 12px; font-weight: 700; padding: 5px 12px; border-radius: 100px; backdrop-filter: blur(8px); font-family: 'Plus Jakarta Sans', sans-serif; letter-spacing: 0.2px; }
//   .vd-badge-preview { background: rgba(14,207,206,0.2); color: #fff; border: 1px solid rgba(14,207,206,0.45); }
//   .vd-badge-purchased { background: rgba(34,197,94,0.2); color: #fff; border: 1px solid rgba(34,197,94,0.45); }

//   .vd-lock-overlay { position: absolute; inset: 0; background: rgba(6,10,18,0.92); backdrop-filter: blur(8px); display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 12px; z-index: 10; padding: 28px; text-align: center; animation: vdLockIn 0.2s ease; }
//   @keyframes vdLockIn { from { opacity: 0; transform: scale(0.98); } to { opacity: 1; transform: scale(1); } }
//   .vd-lock-ring { position: absolute; width: 110px; height: 110px; border-radius: 50%; border: 1.5px solid rgba(14,207,206,0.2); animation: vdRipple 2s ease-in-out infinite; pointer-events: none; }
//   .vd-lock-icon { width: 70px; height: 70px; border-radius: 50%; background: rgba(14,207,206,0.1); border: 1.5px solid rgba(14,207,206,0.3); display: flex; align-items: center; justify-content: center; position: relative; z-index: 1; }
//   .vd-lock-title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 20px; font-weight: 800; color: #f1f5f9; margin: 4px 0 0; letter-spacing: -0.3px; }
//   .vd-lock-sub { font-size: 13.5px; color: #64748b; margin: 0; max-width: 280px; line-height: 1.55; }
//   .vd-lock-actions { display: flex; gap: 10px; margin-top: 4px; }
//   .vd-btn-cart { background: var(--vd-teal); color: #fff; border: none; border-radius: 12px; padding: 11px 26px; font-size: 14px; font-weight: 700; cursor: pointer; display: flex; align-items: center; gap: 8px; transition: opacity 0.2s, transform 0.15s; font-family: 'Plus Jakarta Sans', sans-serif; }
//   .vd-btn-cart:hover:not(:disabled) { opacity: 0.87; transform: translateY(-1px); }
//   .vd-btn-cart.added { background: #16a34a; cursor: default; }
//   .vd-btn-cart:disabled { opacity: 0.7; }
//   .vd-btn-replay { background: transparent; color: #475569; border: 1px solid #2d3748; border-radius: 10px; padding: 11px 20px; font-size: 13px; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 6px; transition: color 0.2s, border-color 0.2s; font-family: 'DM Sans', sans-serif; }
//   .vd-btn-replay:hover { color: #94a3b8; border-color: #475569; }

//   .vd-no-video { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 12px; }
//   .vd-no-video p { color: rgba(255,255,255,0.2); font-size: 13px; margin: 0; }
//   .vd-error { width: 100%; height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 12px; padding: 20px; }
//   .vd-error p { color: rgba(255,255,255,0.25); font-size: 13px; margin: 0; }
//   .vd-btn-retry { background: rgba(14,207,206,0.12); color: var(--vd-teal); border: 1px solid rgba(14,207,206,0.3); border-radius: 8px; padding: 6px 16px; font-size: 12px; font-weight: 600; cursor: pointer; font-family: 'DM Sans', sans-serif; transition: background 0.2s; }
//   .vd-btn-retry:hover { background: rgba(14,207,206,0.2); }

//   .vd-info-block { padding-bottom: 40px; }
//   .vd-title-row { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; margin-bottom: 16px; flex-wrap: wrap; }
//   .vd-title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: clamp(1.45rem, 2.5vw, 2rem); font-weight: 800; color: var(--vd-text-primary); margin: 0; letter-spacing: -0.5px; line-height: 1.25; flex: 1; }
//   .vd-purchased-chip { display: inline-flex; align-items: center; gap: 5px; background: #f0fdf4; color: var(--vd-green-dark); border: 1px solid #bbf7d0; border-radius: 100px; font-size: 12px; font-weight: 700; padding: 5px 12px; font-family: 'Plus Jakarta Sans', sans-serif; white-space: nowrap; flex-shrink: 0; }

//   .vd-mobile-cta { display: none; align-items: center; justify-content: space-between; gap: 12px; padding: 16px 0; border-bottom: 1px solid #f1f5f9; margin-bottom: 20px; }
//   .vd-price-row { display: flex; align-items: baseline; gap: 8px; }
//   .vd-price-current { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 26px; font-weight: 800; color: var(--vd-green); letter-spacing: -0.6px; }
//   .vd-price-old { font-size: 14px; color: var(--vd-text-muted); text-decoration: line-through; font-weight: 500; }
//   .vd-price-free { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 22px; font-weight: 800; color: var(--vd-teal); }

//   .vd-btn-add-mobile { padding: 10px 20px; border-radius: 10px; border: 1.5px solid var(--vd-teal); background: transparent; color: var(--vd-teal); font-size: 13.5px; font-weight: 700; cursor: pointer; display: flex; align-items: center; gap: 6px; transition: background 0.2s, color 0.2s; font-family: 'Plus Jakarta Sans', sans-serif; white-space: nowrap; }
//   .vd-btn-add-mobile:hover:not(:disabled):not(.added) { background: var(--vd-teal); color: #fff; }
//   .vd-btn-add-mobile.added { background: #f0fdf4; border-color: var(--vd-green); color: var(--vd-green-dark); cursor: default; }

//   .vd-tabs-section { display: flex; flex-direction: column; gap: 28px; }
//   .vd-section { background: var(--vd-card-bg); border: 1.5px solid var(--vd-border); border-radius: 16px; padding: 24px 26px; animation: vdFadeUp 0.4s ease both; }
//   @keyframes vdFadeUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
//   .vd-section-title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 15px; font-weight: 700; color: var(--vd-text-primary); margin: 0 0 16px; display: flex; align-items: center; gap: 8px; padding-bottom: 12px; border-bottom: 1px solid #f1f5f9; }
//   .vd-section-title svg { color: var(--vd-teal); flex-shrink: 0; }

//   .vd-html-content p { font-size: 14.5px; color: var(--vd-text-secondary); line-height: 1.75; margin: 0 0 8px; }
//   .vd-html-content ul, .vd-html-content ol { padding-left: 22px; margin: 6px 0; }
//   .vd-html-content li { font-size: 14.5px; color: var(--vd-text-secondary); line-height: 1.7; margin-bottom: 5px; list-style-type: disc; }
//   .vd-html-content ol li { list-style-type: decimal; }
//   .vd-html-content strong { color: var(--vd-text-primary); font-weight: 700; }
//   .vd-html-content a { color: var(--vd-teal); text-decoration: none; }

//   .vd-sidebar { width: var(--vd-sidebar-w); flex-shrink: 0; position: sticky; top: 24px; display: flex; flex-direction: column; gap: 20px; }
//   .vd-sidebar-card { background: var(--vd-card-bg); border: 1.5px solid var(--vd-border); border-radius: 20px; overflow: hidden; box-shadow: 0 4px 24px rgba(0,0,0,0.05); animation: vdFadeUp 0.4s ease both; }
//   .vd-sidebar-thumb { width: 100%; height: 185px; overflow: hidden; position: relative; background: #0d1117; }
//   .vd-sidebar-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
//   .vd-sidebar-thumb-overlay { position: absolute; inset: 0; background: rgba(0,0,0,0.3); display: flex; align-items: center; justify-content: center; }
//   .vd-sidebar-thumb-overlay svg { opacity: 0.7; }

//   .vd-sidebar-price-row { padding: 18px 20px 0; display: flex; align-items: baseline; gap: 10px; flex-wrap: wrap; }
//   .vd-sidebar-price-current { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 28px; font-weight: 800; color: var(--vd-green); letter-spacing: -0.7px; }
//   .vd-sidebar-price-old { font-size: 14px; color: var(--vd-text-muted); text-decoration: line-through; }
//   .vd-sidebar-price-free { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 22px; font-weight: 800; color: var(--vd-teal); }

//   .vd-cta-stack { padding: 14px 20px 16px; display: flex; flex-direction: column; gap: 10px; }
//   .vd-btn-addcart { width: 100%; padding: 13px 0; border-radius: 12px; border: 1.5px solid var(--vd-teal); background: transparent; color: var(--vd-teal); font-size: 14.5px; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; transition: background 0.2s, color 0.2s, transform 0.15s; font-family: 'Plus Jakarta Sans', sans-serif; }
//   .vd-btn-addcart:hover:not(:disabled):not(.added) { background: var(--vd-teal); color: #fff; transform: translateY(-1px); }
//   .vd-btn-addcart.added { background: #f0fdf4; border-color: var(--vd-green); color: var(--vd-green-dark); cursor: default; }
//   .vd-btn-addcart:disabled:not(.added) { opacity: 0.65; cursor: not-allowed; }

//   .vd-owned-block { padding: 14px 20px 16px; }
//   .vd-owned-badge { display: flex; align-items: center; gap: 7px; background: #f0fdf4; color: var(--vd-green-dark); border: 1px solid #bbf7d0; border-radius: 10px; padding: 10px 14px; font-size: 13.5px; font-weight: 700; font-family: 'Plus Jakarta Sans', sans-serif; margin-bottom: 8px; }
//   .vd-owned-sub { font-size: 12.5px; color: var(--vd-text-muted); margin: 0; padding: 0 2px; }

//   .vd-no-purchase { display: flex; align-items: center; gap: 6px; color: var(--vd-text-muted); font-size: 13px; padding: 14px 20px 16px; }

//   .vd-perks { list-style: none; margin: 0; padding: 14px 20px 20px; border-top: 1px solid #f1f5f9; display: flex; flex-direction: column; gap: 9px; }
//   .vd-perks li { display: flex; align-items: center; gap: 8px; font-size: 13px; color: var(--vd-text-secondary); font-family: 'DM Sans', sans-serif; }

//   .vd-related { background: var(--vd-card-bg); border: 1.5px solid var(--vd-border); border-radius: 20px; overflow: hidden; }
//   .vd-related-title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 14px; font-weight: 700; color: var(--vd-text-primary); padding: 16px 18px 12px; border-bottom: 1px solid #f1f5f9; margin: 0; }
//   .vd-related-list { padding: 8px 0; }
//   .vd-related-item { display: flex; gap: 12px; padding: 10px 16px; cursor: pointer; transition: background 0.15s; align-items: center; }
//   .vd-related-item:hover { background: #f8fffe; }
//   .vd-related-thumb { width: 76px; height: 50px; border-radius: 8px; overflow: hidden; flex-shrink: 0; background: #0d1117; position: relative; }
//   .vd-related-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
//   .vd-related-no-thumb { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; }
//   .vd-related-play { position: absolute; inset: 0; background: rgba(0,0,0,0.3); display: flex; align-items: center; justify-content: center; }
//   .vd-related-info { flex: 1; min-width: 0; }
//   .vd-related-name { font-size: 13px; font-weight: 600; color: var(--vd-text-primary); margin: 0 0 4px; line-height: 1.35; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-family: 'Plus Jakarta Sans', sans-serif; }
//   .vd-related-price { font-size: 12.5px; font-weight: 700; color: var(--vd-green); margin: 0; }

//   .vd-spinner { display: inline-block; width: 16px; height: 16px; border: 2px solid rgba(255,255,255,0.3); border-top-color: #fff; border-radius: 50%; animation: vdSpin 0.7s linear infinite; }
//   .vd-spinner-teal { border-color: rgba(14,207,206,0.3); border-top-color: var(--vd-teal); }
//   @keyframes vdSpin { to { transform: rotate(360deg); } }

//   .vd-skeleton-wrap { max-width: 900px; margin: 0 auto; padding: 0 28px; }
//   .vd-skeleton { background: linear-gradient(90deg, #f8fafc 25%, #f1f5f9 50%, #f8fafc 75%); background-size: 200% 100%; animation: vdSkel 1.5s ease-in-out infinite; }
//   @keyframes vdSkel { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }

//   .vd-not-found { text-align: center; padding: 80px 20px; display: flex; flex-direction: column; align-items: center; gap: 12px; }
//   .vd-not-found h2 { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 24px; font-weight: 800; color: var(--vd-text-primary); margin: 0; }
//   .vd-not-found p { color: var(--vd-text-muted); margin: 0; font-size: 15px; }
//   .vd-back-btn { background: var(--vd-teal); color: #fff; border: none; border-radius: 10px; padding: 10px 22px; font-size: 14px; font-weight: 700; cursor: pointer; font-family: 'Plus Jakarta Sans', sans-serif; margin-top: 8px; transition: opacity 0.2s; }
//   .vd-back-btn:hover { opacity: 0.87; }

//   @media (max-width: 1024px) { :root { --vd-sidebar-w: 290px; } }
//   @media (max-width: 820px) {
//     .vd-layout { flex-direction: column; }
//     .vd-sidebar { width: 100%; position: static; }
//     .vd-mobile-cta { display: flex; }
//     .vd-sidebar-card .vd-cta-stack, .vd-sidebar-card .vd-owned-block { display: none; }
//     .vd-player-wrap { border-radius: 14px; }
//     .vd-layout { padding: 0 16px; }
//     .vd-breadcrumb { padding: 0 16px 18px; }
//   }
//   @media (max-width: 480px) {
//     .vd-root { padding: 16px 0 60px; }
//     .vd-title { font-size: 1.35rem; }
//     .vd-lock-actions { flex-direction: column; width: 100%; }
//     .vd-btn-cart, .vd-btn-replay { width: 100%; justify-content: center; }
//   }
// `;

// export default CourseSectionDetailPage;

// Before claude buy now 26 march  2026

// import React, { useEffect, useState, useRef } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import Layout from "../../Layout/Layout";
// import FooterNew from "../../Layout/FooterNew";
// import { useCart } from "../../../Context/CartContext";
// const API_URL = "https://ecom.cyberathon.com/index.php/Api/list_get_product";
// const BASE_URL = "https://ecom.cyberathon.com/";
// const FREE_SECONDS = 10;

// // ─── Guest cart token ─────────────────────────────────────────────────────────
// const getCartToken = () => {
//   let token = localStorage.getItem("cart_token");
//   if (!token) {
//     token = crypto.randomUUID();
//     localStorage.setItem("cart_token", token);
//   }
//   return token;
// };

// // ─── Helpers ──────────────────────────────────────────────────────────────────
// function detectVideoType(url) {
//   if (!url || url.trim() === "") return "no-video";
//   const u = url.toLowerCase();
//   if (u.includes("youtube.com") || u.includes("youtu.be")) return "youtube";
//   if (
//     u.endsWith(".mp4") || u.endsWith(".webm") || u.endsWith(".ogg") ||
//     u.includes(".mp4?") || u.includes("gtv-videos-bucket") ||
//     u.includes("commondatastorage.googleapis.com") || u.includes("archive.org")
//   ) return "mp4";
//   if (u.includes("vimeo.com") || u.includes("dailymotion.com")) return "iframe";
//   return "mp4";
// }

// function buildYouTubeEmbedUrl(raw) {
//   try {
//     if (raw.includes("watch?v=")) {
//       const id = new URLSearchParams(new URL(raw).search).get("v");
//       return `https://www.youtube.com/embed/${id}`;
//     }
//     if (raw.includes("youtu.be/")) return `https://www.youtube.com/embed/${raw.split("youtu.be/")[1].split("?")[0]}`;
//     if (raw.includes("embed/")) return raw;
//   } catch (e) {}
//   return raw;
// }

// function getYouTubeId(embedUrl) {
//   if (!embedUrl) return "";
//   const match = embedUrl.match(/embed\/([^?&]+)/);
//   return match ? match[1] : "";
// }

// function loadYouTubeAPI() {
//   if (window.YT && window.YT.Player) return Promise.resolve();
//   if (window.__ytApiPromise) return window.__ytApiPromise;
//   window.__ytApiPromise = new Promise((resolve) => {
//     window.onYouTubeIframeAPIReady = resolve;
//     const tag = document.createElement("script");
//     tag.src = "https://www.youtube.com/iframe_api";
//     document.body.appendChild(tag);
//   });
//   return window.__ytApiPromise;
// }

// const HtmlContent = ({ html, className = "" }) => {
//   if (!html) return null;
//   return <div className={className} dangerouslySetInnerHTML={{ __html: html }} />;
// };

// // ─── Add to Cart API (guest + logged-in) ─────────────────────────────────────
// async function addToCartApi(prod_id, onSuccess, onError) {
//   const userId    = sessionStorage.getItem("userId");
//   const cartToken = !userId ? getCartToken() : null;

//   if (!userId) {
//     // Guest: try with cart_token
//     try {
//       const listRes = await axios.post(
//         "https://ecom.cyberathon.com/index.php/Api/list_cart",
//         { user_id: null, cart_token: cartToken }
//       );
//       if (listRes.data.status) {
//         const exists = listRes.data.cart_items.find(
//           (i) => String(i.prod_id) === String(prod_id)
//         );
//         if (exists) { onSuccess(); return; }
//       }
//       const res = await axios.post(
//         "https://ecom.cyberathon.com/index.php/Api/insert_cart",
//         { user_id: null, prod_id: Number(prod_id), qty: 1, cart_token: cartToken }
//       );
//       if (res.data.status === true) {
//         onSuccess();
//       } else {
//         sessionStorage.setItem("redirectAfterLogin", window.location.pathname);
//         window.dispatchEvent(new Event("openLoginModal"));
//       }
//     } catch (e) {
//       console.error(e);
//       sessionStorage.setItem("redirectAfterLogin", window.location.pathname);
//       window.dispatchEvent(new Event("openLoginModal"));
//     }
//     return;
//   }

//   // Logged-in
//   try {
//     const listRes = await axios.post(
//       "https://ecom.cyberathon.com/index.php/Api/list_cart",
//       { user_id: userId, cart_token: null }
//     );
//     if (listRes.data.status) {
//       const exists = listRes.data.cart_items.find(
//         (i) => String(i.prod_id) === String(prod_id)
//       );
//       if (exists) { onSuccess(); return; }
//     }
//     const res = await axios.post(
//       "https://ecom.cyberathon.com/index.php/Api/insert_cart",
//       { user_id: Number(userId), prod_id: Number(prod_id), qty: 1 }
//     );
//     if (res.data.status === true) onSuccess();
//     else onError(res.data.message || "Failed to add");
//   } catch (e) {
//     console.error(e);
//     onError("Something went wrong");
//   }
// }

// // ─── Buy Now API ──────────────────────────────────────────────────────────────
// async function buyNowApi(prod_id, navigate, onError, setLoading) {
//   const userId    = sessionStorage.getItem("userId");
//   const cartToken = !userId ? getCartToken() : null;

//   if (!prod_id) { onError("This item is not available."); return; }

//   if (!userId) {
//     sessionStorage.setItem("redirectAfterLogin", "/Bill");
//     sessionStorage.setItem("buyNowProdId", String(prod_id));
//     window.dispatchEvent(new Event("openLoginModal"));
//     setLoading(false);
//     return;
//   }

//   try {
//     const listRes = await axios.post(
//       "https://ecom.cyberathon.com/index.php/Api/list_cart",
//       { user_id: userId, cart_token: null }
//     );
//     let cartItem = null;
//     if (listRes.data.status) {
//       cartItem = listRes.data.cart_items.find(
//         (i) => String(i.prod_id) === String(prod_id)
//       );
//     }
//     if (cartItem) {
//       navigate("/Bill");
//     } else {
//       const res = await axios.post(
//         "https://ecom.cyberathon.com/index.php/Api/insert_cart",
//         { user_id: Number(userId), prod_id: Number(prod_id), qty: 1 }
//       );
//       if (res.data.status === true) navigate("/Bill");
//       else onError(res.data.message || "Failed. Please try again.");
//     }
//   } catch (e) {
//     console.error(e);
//     onError("Something went wrong");
//   } finally {
//     setLoading(false);
//   }
// }

// // ─── Map raw API product ──────────────────────────────────────────────────────
// function mapProduct(p) {
//   let rawUrl = p.video || p.video_url || p.product_video || "";
//   if (rawUrl && !rawUrl.startsWith("http")) rawUrl = BASE_URL + rawUrl;
//   const type = detectVideoType(rawUrl);
//   let embedUrl = rawUrl;
//   if (type === "youtube") embedUrl = buildYouTubeEmbedUrl(rawUrl);
//   return {
//     id: p.id || p.ref_id,
//     prod_id: p.prod_id,
//     heading: p.heading || p.product_name || p.title || "Untitled Course",
//     description: p.description || "",
//     details: p.details || "",
//     current_price: p.current_price || 0,
//     old_price: p.old_price || 0,
//     type,
//     embedUrl,
//   };
// }

// // ─── Video Player ─────────────────────────────────────────────────────────────
// const VideoPlayer = ({ video, isPurchased, isAdded, onAddedChange, navigate , setCartCount}) => {
//   const [phase, setPhase]     = useState("idle");
//   const [loading, setLoading] = useState(false);
//   const [buyLoading, setBuyLoading] = useState(false);
//   const videoRef  = useRef(null);
//   const timerRef  = useRef(null);
//   const playerRef = useRef(null);
//   const divId = `detail-yt-${video.prod_id}`;

//   const videoId = video.type === "youtube" ? getYouTubeId(video.embedUrl) : null;
//   const thumbUrl = videoId ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg` : null;

//   useEffect(() => {
//     if (phase !== "playing" || video.type !== "mp4") return;
//     const vid = videoRef.current;
//     if (!vid || isPurchased) return;
//     const onPlay = () => {
//       timerRef.current = setTimeout(() => { vid.pause(); setPhase("locked"); }, FREE_SECONDS * 1000);
//     };
//     vid.addEventListener("play", onPlay);
//     return () => { vid.removeEventListener("play", onPlay); clearTimeout(timerRef.current); };
//   }, [phase, isPurchased, video.type]);

//   const handlePlay = async () => {
//     if (video.type === "youtube") {
//       setPhase("playing");
//       await loadYouTubeAPI();
//       setTimeout(() => {
//         playerRef.current = new window.YT.Player(divId, {
//           events: {
//             onReady: (e) => {
//               e.target.playVideo();
//               if (!isPurchased) {
//                 timerRef.current = setTimeout(() => {
//                   e.target.pauseVideo(); setPhase("locked");
//                 }, FREE_SECONDS * 1000);
//               }
//             },
//           },
//         });
//       }, 300);
//     } else {
//       setPhase("playing");
//     }
//   };

//   const handleReplay = () => {
//     clearTimeout(timerRef.current);
//     if (playerRef.current) { try { playerRef.current.destroy(); } catch (e) {} playerRef.current = null; }
//     setPhase("idle");
//   };

//   useEffect(() => () => {
//     clearTimeout(timerRef.current);
//     if (playerRef.current) { try { playerRef.current.destroy(); } catch (e) {} }
//   }, []);

//   const handleCartFromLock = async () => {
//     setLoading(true);
//     await addToCartApi(
//       video.prod_id,
//       () => { onAddedChange(true); setLoading(false); setCartCount(prev => prev + 1);},
//       (msg) => { alert(msg); setLoading(false); }
//     );
//   };

//   const handleBuyFromLock = async () => {
//     setBuyLoading(true);
//     await buyNowApi(video.prod_id, navigate, (msg) => { alert(msg); setBuyLoading(false); }, setBuyLoading);
//   };

//   if (video.type === "no-video") {
//     return (
//       <div className="vd-player-wrap vd-no-video">
//         <svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1.2">
//           <rect x="2" y="2" width="20" height="20" rx="2.5" />
//           <path d="M10 8l6 4-6 4V8z" />
//           <line x1="2" y1="2" x2="22" y2="22" />
//         </svg>
//         <p>No video available for this course</p>
//       </div>
//     );
//   }

//   return (
//     <div className="vd-player-wrap">
//       {isPurchased
//         ? <span className="vd-badge vd-badge-purchased"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>Full Access Unlocked</span>
//         : <span className="vd-badge vd-badge-preview"><svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21"/></svg>{FREE_SECONDS}s Free Preview</span>
//       }

//       {phase === "idle" && (
//         <>
//           {video.type === "youtube" && thumbUrl
//             ? <img src={thumbUrl} alt={video.heading} className="vd-thumb" />
//             : video.type === "mp4"
//               ? <video src={`${video.embedUrl}#t=0.5`} className="vd-thumb" preload="metadata" muted playsInline />
//               : <div className="vd-thumb" style={{ background: "#0d1117" }} />
//           }
//           <div className="vd-play-overlay" onClick={handlePlay}>
//             <div className="vd-play-ripple" />
//             <button className="vd-play-btn">
//               <svg width="28" height="28" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21"/></svg>
//             </button>
//             <p className="vd-play-hint">Click to play {isPurchased ? "full video" : "free preview"}</p>
//           </div>
//         </>
//       )}

//       {phase === "playing" && (
//         <>
//           {video.type === "youtube" && (
//             <iframe id={divId} src={`https://www.youtube.com/embed/${videoId}?enablejsapi=1`} title={video.heading}
//               allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen
//               style={{ width: "100%", height: "100%", border: "none", display: "block" }} />
//           )}
//           {video.type === "mp4" && (
//             <video ref={videoRef} src={video.embedUrl} controls={isPurchased} autoPlay playsInline
//               onError={() => setPhase("error")} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
//           )}
//           {video.type === "iframe" && (
//             <iframe src={video.embedUrl} title={video.heading} allow="autoplay; fullscreen" allowFullScreen
//               style={{ width: "100%", height: "100%", border: "none", display: "block" }} />
//           )}
//         </>
//       )}

//       {phase === "locked" && (
//         <>
//           {video.type === "youtube" && thumbUrl && (
//             <img src={thumbUrl} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", filter: "blur(8px) brightness(0.3)" }} />
//           )}
//           <div className="vd-lock-overlay">
//             <div className="vd-lock-ring" />
//             <div className="vd-lock-icon">
//               <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
//               </svg>
//             </div>
//             <h3 className="vd-lock-title">Preview Ended</h3>
//             <p className="vd-lock-sub">Purchase this course to watch the full video</p>
//             {video.prod_id && (
//               <div className="vd-lock-actions">
//                 {/* Add to Cart */}
//                 <button className={`vd-btn-cart${isAdded ? " added" : ""}`} onClick={handleCartFromLock} disabled={loading || isAdded}>
//                   {loading ? <span className="vd-spinner" /> :
//                     isAdded
//                       ? <><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg> Added to Cart</>
//                       : <><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Add to Cart</>
//                   }
//                 </button>
//                 {/* Buy Now */}
//                 <button className="vd-btn-buy-lock" onClick={handleBuyFromLock} disabled={buyLoading}>
//                   {buyLoading ? <span className="vd-spinner" /> : "Buy Now"}
//                 </button>
//               </div>
//             )}
//             <button className="vd-btn-replay" onClick={handleReplay}>
//               <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-6"/></svg>
//               Replay Preview
//             </button>
//           </div>
//         </>
//       )}

//       {phase === "error" && (
//         <div className="vd-error">
//           <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="1.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
//           <p>Video could not be loaded</p>
//           <button className="vd-btn-retry" onClick={() => setPhase("idle")}>Try Again</button>
//         </div>
//       )}
//     </div>
//   );
// };

// // ─── MAIN DETAIL PAGE ─────────────────────────────────────────────────────────
// const CourseSectionDetailPage = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const { setCartCount } = useCart();

//   const [video, setVideo]           = useState(null);
//   const [loading, setLoading]       = useState(true);
//   const [isPurchased, setIsPurchased] = useState(false);
//   const [isAdded, setIsAdded]       = useState(false);
//   const [cartLoading, setCartLoading] = useState(false);
//   const [buyLoading, setBuyLoading]   = useState(false);
//   const [relatedVideos, setRelatedVideos] = useState([]);

//   useEffect(() => {
//     const load = async () => {
//       try {
//         const res = await axios.get(API_URL);
//         if (!res.data?.status) { setLoading(false); return; }

//         const products = Array.isArray(res.data.products) ? res.data.products : [];
//         const all = products
//           .filter((p) => p.product_type && p.product_type.toLowerCase() === "coursesection")
//           .map(mapProduct);

//         const found = all.find((v) => String(v.prod_id) === String(id));
//         setVideo(found || null);
//         setRelatedVideos(all.filter((v) => String(v.prod_id) !== String(id)).slice(0, 4));

//         if (!found) { setLoading(false); return; }

//         // Cart check (guest + logged-in)
//         const userId    = sessionStorage.getItem("userId");
//         const cartToken = localStorage.getItem("cart_token");

//         if (userId || cartToken) {
//           try {
//             const cr = await axios.post("https://ecom.cyberathon.com/index.php/Api/list_cart", {
//               user_id:    userId || null,
//               cart_token: userId ? null : cartToken,
//             });
//             if (cr.data.status) {
//               const inCart = cr.data.cart_items.some((i) => String(i.prod_id) === String(found.prod_id));
//               setIsAdded(inCart);
//             }
//             if (cr.data.status) {
//   const items = cr.data.cart_items || [];

//   setCartCount(items.length); // ✅ sync count
// }
//           } catch (e) {}
//         }

//         // Purchase check (logged-in only)
//         if (userId) {
//           try {
//             const or = await axios.post("https://ecom.cyberathon.com/index.php/Api/list_new_order", {
//               user_id: parseInt(userId),
//             });
//             if (or.data.status && Array.isArray(or.data.orders)) {
//               const purchased = or.data.orders.some((order) =>
//                 Array.isArray(order.items) &&
//                 order.items.some((item) => {
//                   if (String(item.prod_id) !== String(found.prod_id)) return false;
//                   return (
//                     item.access === "unlocked" ||
//                     order.purchase_status === "yes" ||
//                     order.payment_status === "Paid" ||
//                     order.payment_status === "paid" ||
//                     order.order_status === "Delivered" ||
//                     order.order_status === "Completed"
//                   );
//                 })
//               );
//               setIsPurchased(purchased);
//             }
//           } catch (e) {}
//         }
//       } catch (e) {
//         console.error(e);
//       } finally {
//         setLoading(false);
//       }
//     };

//     load();
//     window.scrollTo(0, 0);

//     // Re-check on login
//     const onLogin = () => load();
//     window.addEventListener("userLoggedIn", onLogin);
//     return () => window.removeEventListener("userLoggedIn", onLogin);
//   }, [id]);

//   // ── Add to Cart handler ──────────────────────────────────────────────────
//   const handleAddToCart = () => {
//     if (isAdded || cartLoading || !video?.prod_id) return;
//     setCartLoading(true);
//     addToCartApi(
//       video.prod_id,
//       () => { setIsAdded(true); setCartLoading(false);   setCartCount(prev => prev + 1);},
//       (msg) => { alert(msg); setCartLoading(false); }
//     );
//   };

//   // ── Buy Now handler ──────────────────────────────────────────────────────
//   const handleBuyNow = () => {
//     if (buyLoading || !video?.prod_id) return;
//     setBuyLoading(true);
//     buyNowApi(video.prod_id, navigate, (msg) => { alert(msg); setBuyLoading(false); }, setBuyLoading);
//   };

//   // ── Loading skeleton ──────────────────────────────────────────────────────
//   if (loading) {
//     return (
//       <>
//         <style>{detailStyles}</style>
//         <div className="vd-root">
//           <div className="vd-skeleton-wrap">
//             <div className="vd-skeleton" style={{ height: 480, borderRadius: 20, marginBottom: 32 }} />
//             <div className="vd-skeleton" style={{ height: 28, width: "60%", marginBottom: 16 }} />
//             <div className="vd-skeleton" style={{ height: 16, width: "80%", marginBottom: 10 }} />
//             <div className="vd-skeleton" style={{ height: 16, width: "70%" }} />
//           </div>
//         </div>
//       </>
//     );
//   }

//   // ── Not Found ─────────────────────────────────────────────────────────────
//   if (!video) {
//     return (
//       <>
//         <style>{detailStyles}</style>
//         <div className="vd-root">
//           <div className="vd-not-found">
//             <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
//             <h2>Course Not Found</h2>
//             <p>This course doesn't exist or has been removed.</p>
//             <button className="vd-back-btn" onClick={() => navigate(-1)}>← Go Back</button>
//           </div>
//         </div>
//       </>
//     );
//   }

//   const hasPaid = video.current_price && Number(video.current_price) > 0;

//   return (
//     <>
//       <Layout />
//       <style>{detailStyles}</style>
//       <div className="vd-root">

//         {/* Breadcrumb */}
//         <div className="vd-breadcrumb">
//           <button onClick={() => navigate(-1)} className="vd-back-link">
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="15 18 9 12 15 6"/></svg>
//             Back to Courses
//           </button>
//           <span className="vd-breadcrumb-sep">/</span>
//           <span className="vd-breadcrumb-current">{video.heading}</span>
//         </div>

//         <div className="vd-layout">
//           <div className="vd-main">

//             {/* Video Player */}
//             <VideoPlayer
//               video={video}
//               isPurchased={isPurchased}
//               isAdded={isAdded}
//               onAddedChange={setIsAdded}
//               navigate={navigate}
//                setCartCount={setCartCount}
//             />

//             <div className="vd-info-block">
//               <div className="vd-title-row">
//                 <h1 className="vd-title">{video.heading}</h1>
//                 {isPurchased && (
//                   <span className="vd-purchased-chip">
//                     <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
//                     Purchased
//                   </span>
//                 )}
//               </div>

//               {/* Mobile CTA */}
//               <div className="vd-mobile-cta">
//                 <div className="vd-price-row">
//                   {hasPaid ? (
//                     <>
//                       <span className="vd-price-current">₹{Number(video.current_price).toLocaleString("en-IN")}</span>
//                       {video.old_price && Number(video.old_price) > 0 && (
//                         <span className="vd-price-old">₹{Number(video.old_price).toLocaleString("en-IN")}</span>
//                       )}
//                     </>
//                   ) : (
//                     <span className="vd-price-free">Free</span>
//                   )}
//                 </div>
//                 {video.prod_id && !isPurchased && (
//                   <div className="vd-mobile-action-row">
//                     <button className={`vd-btn-add-mobile${isAdded ? " added" : ""}`} onClick={handleAddToCart} disabled={cartLoading || isAdded}>
//                       {cartLoading ? <span className="vd-spinner" /> :
//                         isAdded
//                           ? <><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg> Added</>
//                           : <><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Add to Cart</>
//                       }
//                     </button>
//                     <button className="vd-btn-buy-mobile" onClick={handleBuyNow} disabled={buyLoading}>
//                       {buyLoading ? <span className="vd-spinner" /> : "Buy Now"}
//                     </button>
//                   </div>
//                 )}
//               </div>

//               {/* Content sections */}
//               <div className="vd-tabs-section">
//                 {video.description && (
//                   <div className="vd-section">
//                     <h3 className="vd-section-title">
//                       <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
//                       About This Course
//                     </h3>
//                     <div className="vd-html-content"><HtmlContent html={video.description} /></div>
//                   </div>
//                 )}
//                 {video.details && (
//                   <div className="vd-section">
//                     <h3 className="vd-section-title">
//                       <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
//                       What You'll Learn
//                     </h3>
//                     <div className="vd-html-content vd-learn-list"><HtmlContent html={video.details} /></div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* RIGHT Sidebar */}
//           <div className="vd-sidebar">
//             <div className="vd-sidebar-card">
//               {/* Thumbnail */}
//               <div className="vd-sidebar-thumb">
//                 {video.type === "youtube" && getYouTubeId(video.embedUrl) ? (
//                   <img src={`https://img.youtube.com/vi/${getYouTubeId(video.embedUrl)}/hqdefault.jpg`} alt={video.heading} />
//                 ) : video.type === "mp4" ? (
//                   <video src={`${video.embedUrl}#t=0.5`} muted playsInline preload="metadata" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//                 ) : (
//                   <div style={{ width: "100%", height: "100%", background: "linear-gradient(135deg,#0d1117,#1a2332)", display: "flex", alignItems: "center", justifyContent: "center" }}>
//                     <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1.2"><rect x="2" y="2" width="20" height="20" rx="2.5"/><path d="M10 8l6 4-6 4V8z"/></svg>
//                   </div>
//                 )}
//                 <div className="vd-sidebar-thumb-overlay">
//                   <svg width="22" height="22" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21"/></svg>
//                 </div>
//               </div>

//               {/* Price */}
//               <div className="vd-sidebar-price-row">
//                 {hasPaid ? (
//                   <>
//                     <span className="vd-sidebar-price-current">₹{Number(video.current_price).toLocaleString("en-IN")}</span>
//                     {video.old_price && Number(video.old_price) > 0 && (
//                       <span className="vd-sidebar-price-old">₹{Number(video.old_price).toLocaleString("en-IN")}</span>
//                     )}
//                   </>
//                 ) : (
//                   <span className="vd-sidebar-price-free">Free</span>
//                 )}
//               </div>

//               {/* CTA */}
//               {!video.prod_id ? (
//                 <div className="vd-no-purchase">
//                   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
//                   Not available for purchase
//                 </div>
//               ) : isPurchased ? (
//                 <div className="vd-owned-block">
//                   <div className="vd-owned-badge">
//                     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
//                     You own this course
//                   </div>
//                   <p className="vd-owned-sub">You have full lifetime access</p>
//                 </div>
//               ) : (
//                 <div className="vd-cta-stack">
//                   {/* Add to Cart */}
//                   <button
//                     className={`vd-btn-addcart${isAdded ? " added" : ""}`}
//                     onClick={handleAddToCart}
//                     disabled={cartLoading || isAdded}
//                   >
//                     {cartLoading ? (
//                       <span className="vd-spinner vd-spinner-teal" />
//                     ) : isAdded ? (
//                       <><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg> Added to Cart</>
//                     ) : (
//                       <><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Add to Cart</>
//                     )}
//                   </button>
//                   {/* Buy Now */}
//                   <button
//                     className="vd-btn-buynow"
//                     onClick={handleBuyNow}
//                     disabled={buyLoading}
//                   >
//                     {buyLoading ? <span className="vd-spinner" /> : "Buy Now"}
//                   </button>
//                 </div>
//               )}

//               {/* Perks */}
//               <ul className="vd-perks">
//                 <li><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>Lifetime access after purchase</li>
//                 <li><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>Watch on any device</li>
//                 <li><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>Free {FREE_SECONDS}s preview available</li>
//               </ul>
//             </div>

//             {/* Related Videos */}
//             {relatedVideos.length > 0 && (
//               <div className="vd-related">
//                 <h3 className="vd-related-title">More Courses</h3>
//                 <div className="vd-related-list">
//                   {relatedVideos.map((rv) => {
//                     const rvId = rv.type === "youtube" ? getYouTubeId(rv.embedUrl) : null;
//                     return (
//                       <div key={rv.prod_id} className="vd-related-item"
//                         onClick={() => navigate(`/coursesectiondetail/${rv.prod_id}`)}>
//                         <div className="vd-related-thumb">
//                           {rvId
//                             ? <img src={`https://img.youtube.com/vi/${rvId}/hqdefault.jpg`} alt={rv.heading} />
//                             : rv.type === "mp4"
//                               ? <video src={`${rv.embedUrl}#t=0.5`} muted playsInline preload="metadata" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//                               : <div className="vd-related-no-thumb"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1.5"><rect x="2" y="2" width="20" height="20" rx="2"/><path d="M10 8l6 4-6 4V8z"/></svg></div>
//                           }
//                           <div className="vd-related-play">
//                             <svg width="10" height="10" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21"/></svg>
//                           </div>
//                         </div>
//                         <div className="vd-related-info">
//                           <p className="vd-related-name">{rv.heading}</p>
//                           <p className="vd-related-price">
//                             {rv.current_price && Number(rv.current_price) > 0
//                               ? `₹${Number(rv.current_price).toLocaleString("en-IN")}`
//                               : "Free"}
//                           </p>
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//       <FooterNew />
//     </>
//   );
// };

// // ─── STYLES ───────────────────────────────────────────────────────────────────
// const detailStyles = `
//   @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=DM+Sans:ital,wght@0,400;0,500;0,600;1,400&display=swap');

//   :root {
//     --vd-teal: #0ecfce;
//     --vd-teal-dark: #0ab5b4;
//     --vd-green: #22c55e;
//     --vd-green-dark: #16a34a;
//     --vd-amber: #f59e0b;
//     --vd-amber-dark: #d97706;
//     --vd-text-primary: #0f172a;
//     --vd-text-secondary: #475569;
//     --vd-text-muted: #94a3b8;
//     --vd-surface: #f7fffe;
//     --vd-card-bg: #ffffff;
//     --vd-border: #e5f0f0;
//     --vd-sidebar-w: 340px;
//   }

//   .vd-root { background: var(--vd-surface); min-height: 100vh; padding: 28px 0 80px; font-family: 'DM Sans', sans-serif; }

//   .vd-breadcrumb { display: flex; align-items: center; gap: 8px; padding: 0 28px 22px; max-width: 1280px; margin: 0 auto; font-size: 13.5px; color: var(--vd-text-muted); flex-wrap: wrap; }
//   .vd-back-link { display: flex; align-items: center; gap: 4px; color: var(--vd-teal); background: none; border: none; cursor: pointer; font-size: 13.5px; font-weight: 600; padding: 0; font-family: 'DM Sans', sans-serif; transition: opacity 0.2s; }
//   .vd-back-link:hover { opacity: 0.75; }
//   .vd-breadcrumb-sep { color: #cbd5e1; }
//   .vd-breadcrumb-current { color: var(--vd-text-secondary); font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 260px; }

//   .vd-layout { display: flex; gap: 32px; padding: 0 28px; max-width: 1280px; margin: 0 auto; align-items: flex-start; }
//   .vd-main { flex: 1; min-width: 0; }

//   /* ── Player ── */
//   .vd-player-wrap { position: relative; width: 100%; aspect-ratio: 16/9; background: #0d1117; border-radius: 20px; overflow: hidden; margin-bottom: 28px; box-shadow: 0 8px 40px rgba(0,0,0,0.12); }
//   .vd-thumb { width: 100%; height: 100%; object-fit: cover; display: block; }
//   .vd-play-overlay { position: absolute; inset: 0; background: linear-gradient(to top, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.1) 60%, transparent 100%); display: flex; flex-direction: column; align-items: center; justify-content: center; cursor: pointer; gap: 14px; transition: background 0.2s; }
//   .vd-play-overlay:hover { background: linear-gradient(to top, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.2) 60%, transparent 100%); }
//   .vd-play-ripple { position: absolute; width: 100px; height: 100px; border-radius: 50%; border: 1.5px solid rgba(14,207,206,0.3); animation: vdRipple 2s ease-in-out infinite; pointer-events: none; }
//   @keyframes vdRipple { 0%,100% { transform: scale(1); opacity: 0.6; } 50% { transform: scale(1.4); opacity: 0; } }
//   .vd-play-btn { width: 72px; height: 72px; border-radius: 50%; background: var(--vd-teal); border: 3px solid rgba(255,255,255,0.25); display: flex; align-items: center; justify-content: center; cursor: pointer; position: relative; z-index: 2; transition: transform 0.2s cubic-bezier(.22,.68,0,1.4), background 0.2s; box-shadow: 0 6px 32px rgba(14,207,206,0.5); }
//   .vd-play-btn:hover { transform: scale(1.1); background: var(--vd-teal-dark); }
//   .vd-play-btn svg { margin-left: 4px; }
//   .vd-play-hint { font-size: 13px; color: rgba(255,255,255,0.7); font-family: 'DM Sans', sans-serif; font-weight: 500; position: relative; z-index: 2; margin: 0; }

//   .vd-badge { position: absolute; top: 16px; left: 16px; z-index: 8; display: inline-flex; align-items: center; gap: 5px; font-size: 12px; font-weight: 700; padding: 5px 12px; border-radius: 100px; backdrop-filter: blur(8px); font-family: 'Plus Jakarta Sans', sans-serif; letter-spacing: 0.2px; }
//   .vd-badge-preview { background: rgba(14,207,206,0.2); color: #fff; border: 1px solid rgba(14,207,206,0.45); }
//   .vd-badge-purchased { background: rgba(34,197,94,0.2); color: #fff; border: 1px solid rgba(34,197,94,0.45); }

//   /* ── Lock Overlay ── */
//   .vd-lock-overlay { position: absolute; inset: 0; background: rgba(6,10,18,0.92); backdrop-filter: blur(8px); display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 10px; z-index: 10; padding: 28px; text-align: center; animation: vdLockIn 0.2s ease; }
//   @keyframes vdLockIn { from { opacity: 0; transform: scale(0.98); } to { opacity: 1; transform: scale(1); } }
//   .vd-lock-ring { position: absolute; width: 110px; height: 110px; border-radius: 50%; border: 1.5px solid rgba(14,207,206,0.2); animation: vdRipple 2s ease-in-out infinite; pointer-events: none; }
//   .vd-lock-icon { width: 70px; height: 70px; border-radius: 50%; background: rgba(14,207,206,0.1); border: 1.5px solid rgba(14,207,206,0.3); display: flex; align-items: center; justify-content: center; position: relative; z-index: 1; }
//   .vd-lock-title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 20px; font-weight: 800; color: #f1f5f9; margin: 4px 0 0; letter-spacing: -0.3px; }
//   .vd-lock-sub { font-size: 13.5px; color: #64748b; margin: 0; max-width: 280px; line-height: 1.55; }
//   .vd-lock-actions { display: flex; gap: 10px; margin-top: 4px; flex-wrap: wrap; justify-content: center; }

//   /* Lock overlay — Add to Cart */
//   .vd-btn-cart { background: linear-gradient(135deg, #24aeb1, #058587); color: #fff; border: none; border-radius: 12px; padding: 11px 22px; font-size: 14px; font-weight: 700; cursor: pointer; display: flex; align-items: center; gap: 8px; transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s; font-family: 'Plus Jakarta Sans', sans-serif; box-shadow: 0 2px 12px rgba(36,174,177,0.35); }
//   .vd-btn-cart:hover:not(:disabled):not(.added) { opacity: 0.88; transform: translateY(-1px); box-shadow: 0 4px 18px rgba(36,174,177,0.5); }
//   .vd-btn-cart.added { background: linear-gradient(135deg, #24aeb1, #058587); cursor: default; opacity: 0.85; }
//   .vd-btn-cart:disabled:not(.added) { opacity: 0.7; cursor: not-allowed; }

//   /* Lock overlay — Buy Now */
//   .vd-btn-buy-lock { background: linear-gradient(135deg, #24aeb1, #058587); color: #fff; border: none; border-radius: 12px; padding: 11px 22px; font-size: 14px; font-weight: 700; cursor: pointer; display: flex; align-items: center; gap: 8px; transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s; font-family: 'Plus Jakarta Sans', sans-serif; box-shadow: 0 2px 12px rgba(36,174,177,0.35); }
//   .vd-btn-buy-lock:hover:not(:disabled) { opacity: 0.88; transform: translateY(-1px); box-shadow: 0 4px 18px rgba(36,174,177,0.5); }
//   .vd-btn-buy-lock:disabled { opacity: 0.7; cursor: not-allowed; }

//   .vd-btn-replay { background: transparent; color: #475569; border: 1px solid #2d3748; border-radius: 10px; padding: 11px 20px; font-size: 13px; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 6px; transition: color 0.2s, border-color 0.2s; font-family: 'DM Sans', sans-serif; }
//   .vd-btn-replay:hover { color: #94a3b8; border-color: #475569; }

//   .vd-no-video { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 12px; }
//   .vd-no-video p { color: rgba(255,255,255,0.2); font-size: 13px; margin: 0; }
//   .vd-error { width: 100%; height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 12px; padding: 20px; }
//   .vd-error p { color: rgba(255,255,255,0.25); font-size: 13px; margin: 0; }
//   .vd-btn-retry { background: rgba(14,207,206,0.12); color: var(--vd-teal); border: 1px solid rgba(14,207,206,0.3); border-radius: 8px; padding: 6px 16px; font-size: 12px; font-weight: 600; cursor: pointer; font-family: 'DM Sans', sans-serif; transition: background 0.2s; }
//   .vd-btn-retry:hover { background: rgba(14,207,206,0.2); }

//   /* ── Info Block ── */
//   .vd-info-block { padding-bottom: 40px; }
//   .vd-title-row { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; margin-bottom: 16px; flex-wrap: wrap; }
//   .vd-title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: clamp(1.45rem, 2.5vw, 2rem); font-weight: 800; color: var(--vd-text-primary); margin: 0; letter-spacing: -0.5px; line-height: 1.25; flex: 1; }
//   .vd-purchased-chip { display: inline-flex; align-items: center; gap: 5px; background: #f0fdf4; color: var(--vd-green-dark); border: 1px solid #bbf7d0; border-radius: 100px; font-size: 12px; font-weight: 700; padding: 5px 12px; font-family: 'Plus Jakarta Sans', sans-serif; white-space: nowrap; flex-shrink: 0; }

//   /* Mobile CTA */
//   .vd-mobile-cta { display: none; flex-direction: column; gap: 10px; padding: 16px 0; border-bottom: 1px solid #f1f5f9; margin-bottom: 20px; }
//   .vd-price-row { display: flex; align-items: baseline; gap: 8px; }
//   .vd-price-current { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 26px; font-weight: 800; color: var(--vd-green); letter-spacing: -0.6px; }
//   .vd-price-old { font-size: 14px; color: var(--vd-text-muted); text-decoration: line-through; font-weight: 500; }
//   .vd-price-free { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 22px; font-weight: 800; color: var(--vd-teal); }

//   /* Mobile action row — Add to Cart + Buy Now */
//   .vd-mobile-action-row { display: flex; gap: 8px; }
//   .vd-btn-add-mobile { flex: 1; padding: 10px 0; border-radius: 10px; border: none; background: linear-gradient(135deg, #24aeb1, #058587); color: #fff; font-size: 13.5px; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 6px; transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s; font-family: 'Plus Jakarta Sans', sans-serif; white-space: nowrap; box-shadow: 0 2px 10px rgba(36,174,177,0.35); }
//   .vd-btn-add-mobile:hover:not(:disabled):not(.added) { opacity: 0.88; transform: translateY(-1px); box-shadow: 0 4px 16px rgba(36,174,177,0.5); }
//   .vd-btn-add-mobile.added { opacity: 0.8; cursor: default; }
//   .vd-btn-add-mobile:disabled:not(.added) { opacity: 0.65; cursor: not-allowed; }

//   .vd-btn-buy-mobile { flex: 1; padding: 10px 0; border-radius: 10px; border: none; background: linear-gradient(135deg, #24aeb1, #058587); color: #fff; font-size: 13.5px; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s; font-family: 'Plus Jakarta Sans', sans-serif; box-shadow: 0 2px 10px rgba(36,174,177,0.35); }
//   .vd-btn-buy-mobile:hover:not(:disabled) { opacity: 0.88; transform: translateY(-1px); box-shadow: 0 4px 16px rgba(36,174,177,0.5); }
//   .vd-btn-buy-mobile:disabled { opacity: 0.65; cursor: not-allowed; }

//   .vd-tabs-section { display: flex; flex-direction: column; gap: 28px; }
//   .vd-section { background: var(--vd-card-bg); border: 1.5px solid var(--vd-border); border-radius: 16px; padding: 24px 26px; animation: vdFadeUp 0.4s ease both; }
//   @keyframes vdFadeUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
//   .vd-section-title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 15px; font-weight: 700; color: var(--vd-text-primary); margin: 0 0 16px; display: flex; align-items: center; gap: 8px; padding-bottom: 12px; border-bottom: 1px solid #f1f5f9; }
//   .vd-section-title svg { color: var(--vd-teal); flex-shrink: 0; }
//   .vd-html-content p { font-size: 14.5px; color: var(--vd-text-secondary); line-height: 1.75; margin: 0 0 8px; }
//   .vd-html-content ul, .vd-html-content ol { padding-left: 22px; margin: 6px 0; }
//   .vd-html-content li { font-size: 14.5px; color: var(--vd-text-secondary); line-height: 1.7; margin-bottom: 5px; list-style-type: disc; }
//   .vd-html-content ol li { list-style-type: decimal; }
//   .vd-html-content strong { color: var(--vd-text-primary); font-weight: 700; }
//   .vd-html-content a { color: var(--vd-teal); text-decoration: none; }

//   /* ── Sidebar ── */
//   .vd-sidebar { width: var(--vd-sidebar-w); flex-shrink: 0; position: sticky; top: 24px; display: flex; flex-direction: column; gap: 20px; }
//   .vd-sidebar-card { background: var(--vd-card-bg); border: 1.5px solid var(--vd-border); border-radius: 20px; overflow: hidden; box-shadow: 0 4px 24px rgba(0,0,0,0.05); animation: vdFadeUp 0.4s ease both; }
//   .vd-sidebar-thumb { width: 100%; height: 185px; overflow: hidden; position: relative; background: #0d1117; }
//   .vd-sidebar-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
//   .vd-sidebar-thumb-overlay { position: absolute; inset: 0; background: rgba(0,0,0,0.3); display: flex; align-items: center; justify-content: center; }
//   .vd-sidebar-thumb-overlay svg { opacity: 0.7; }
//   .vd-sidebar-price-row { padding: 18px 20px 0; display: flex; align-items: baseline; gap: 10px; flex-wrap: wrap; }
//   .vd-sidebar-price-current { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 28px; font-weight: 800; color: var(--vd-green); letter-spacing: -0.7px; }
//   .vd-sidebar-price-old { font-size: 14px; color: var(--vd-text-muted); text-decoration: line-through; }
//   .vd-sidebar-price-free { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 22px; font-weight: 800; color: var(--vd-teal); }

//   /* Sidebar CTA stack */
//   .vd-cta-stack { padding: 14px 20px 16px; display: flex; flex-direction: column; gap: 10px; }

//   /* Sidebar Add to Cart */
//   .vd-btn-addcart { width: 100%; padding: 13px 0; border-radius: 12px; border: none; background: linear-gradient(135deg, #24aeb1, #058587); color: #fff; font-size: 14.5px; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s; font-family: 'Plus Jakarta Sans', sans-serif; box-shadow: 0 2px 14px rgba(36,174,177,0.35); }
//   .vd-btn-addcart:hover:not(:disabled):not(.added) { opacity: 0.88; transform: translateY(-1px); box-shadow: 0 4px 20px rgba(36,174,177,0.5); }
//   .vd-btn-addcart.added { opacity: 0.8; cursor: default; }
//   .vd-btn-addcart:disabled:not(.added) { opacity: 0.65; cursor: not-allowed; }

//   /* Sidebar Buy Now */
//   .vd-btn-buynow { width: 100%; padding: 13px 0; border-radius: 12px; border: none; background: linear-gradient(135deg, #24aeb1, #058587); color: #fff; font-size: 14.5px; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s; font-family: 'Plus Jakarta Sans', sans-serif; box-shadow: 0 2px 14px rgba(36,174,177,0.35); }
//   .vd-btn-buynow:hover:not(:disabled) { opacity: 0.88; transform: translateY(-1px); box-shadow: 0 4px 20px rgba(36,174,177,0.5); }
//   .vd-btn-buynow:disabled { opacity: 0.65; cursor: not-allowed; }

//   .vd-owned-block { padding: 14px 20px 16px; }
//   .vd-owned-badge { display: flex; align-items: center; gap: 7px; background: #f0fdf4; color: var(--vd-green-dark); border: 1px solid #bbf7d0; border-radius: 10px; padding: 10px 14px; font-size: 13.5px; font-weight: 700; font-family: 'Plus Jakarta Sans', sans-serif; margin-bottom: 8px; }
//   .vd-owned-sub { font-size: 12.5px; color: var(--vd-text-muted); margin: 0; padding: 0 2px; }
//   .vd-no-purchase { display: flex; align-items: center; gap: 6px; color: var(--vd-text-muted); font-size: 13px; padding: 14px 20px 16px; }

//   .vd-perks { list-style: none; margin: 0; padding: 14px 20px 20px; border-top: 1px solid #f1f5f9; display: flex; flex-direction: column; gap: 9px; }
//   .vd-perks li { display: flex; align-items: center; gap: 8px; font-size: 13px; color: var(--vd-text-secondary); font-family: 'DM Sans', sans-serif; }

//   /* Related */
//   .vd-related { background: var(--vd-card-bg); border: 1.5px solid var(--vd-border); border-radius: 20px; overflow: hidden; }
//   .vd-related-title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 14px; font-weight: 700; color: var(--vd-text-primary); padding: 16px 18px 12px; border-bottom: 1px solid #f1f5f9; margin: 0; }
//   .vd-related-list { padding: 8px 0; }
//   .vd-related-item { display: flex; gap: 12px; padding: 10px 16px; cursor: pointer; transition: background 0.15s; align-items: center; }
//   .vd-related-item:hover { background: #f8fffe; }
//   .vd-related-thumb { width: 76px; height: 50px; border-radius: 8px; overflow: hidden; flex-shrink: 0; background: #0d1117; position: relative; }
//   .vd-related-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
//   .vd-related-no-thumb { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; }
//   .vd-related-play { position: absolute; inset: 0; background: rgba(0,0,0,0.3); display: flex; align-items: center; justify-content: center; }
//   .vd-related-info { flex: 1; min-width: 0; }
//   .vd-related-name { font-size: 13px; font-weight: 600; color: var(--vd-text-primary); margin: 0 0 4px; line-height: 1.35; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-family: 'Plus Jakarta Sans', sans-serif; }
//   .vd-related-price { font-size: 12.5px; font-weight: 700; color: var(--vd-green); margin: 0; }

//   /* Spinners */
//   .vd-spinner { display: inline-block; width: 16px; height: 16px; border: 2px solid rgba(255,255,255,0.3); border-top-color: #fff; border-radius: 50%; animation: vdSpin 0.7s linear infinite; }
//   .vd-spinner-teal { border-color: rgba(14,207,206,0.3); border-top-color: var(--vd-teal); }
//   @keyframes vdSpin { to { transform: rotate(360deg); } }

//   /* Skeleton */
//   .vd-skeleton-wrap { max-width: 900px; margin: 0 auto; padding: 0 28px; }
//   .vd-skeleton { background: linear-gradient(90deg, #f8fafc 25%, #f1f5f9 50%, #f8fafc 75%); background-size: 200% 100%; animation: vdSkel 1.5s ease-in-out infinite; }
//   @keyframes vdSkel { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }

//   .vd-not-found { text-align: center; padding: 80px 20px; display: flex; flex-direction: column; align-items: center; gap: 12px; }
//   .vd-not-found h2 { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 24px; font-weight: 800; color: var(--vd-text-primary); margin: 0; }
//   .vd-not-found p { color: var(--vd-text-muted); margin: 0; font-size: 15px; }
//   .vd-back-btn { background: var(--vd-teal); color: #fff; border: none; border-radius: 10px; padding: 10px 22px; font-size: 14px; font-weight: 700; cursor: pointer; font-family: 'Plus Jakarta Sans', sans-serif; margin-top: 8px; transition: opacity 0.2s; }
//   .vd-back-btn:hover { opacity: 0.87; }

//   @media (max-width: 1024px) { :root { --vd-sidebar-w: 290px; } }
//   @media (max-width: 820px) {
//     .vd-layout { flex-direction: column; }
//     .vd-sidebar { width: 100%; position: static; }
//     .vd-mobile-cta { display: flex; }
//     .vd-sidebar-card .vd-cta-stack, .vd-sidebar-card .vd-owned-block { display: none; }
//     .vd-player-wrap { border-radius: 14px; }
//     .vd-layout { padding: 0 16px; }
//     .vd-breadcrumb { padding: 0 16px 18px; }
//   }
//   @media (max-width: 480px) {
//     .vd-root { padding: 16px 0 60px; }
//     .vd-title { font-size: 1.35rem; }
//     .vd-lock-actions { flex-direction: column; width: 100%; }
//     .vd-btn-cart, .vd-btn-buy-lock, .vd-btn-replay { width: 100%; justify-content: center; }
//     .vd-mobile-action-row { flex-direction: column; }
//   }
// `;

// export default CourseSectionDetailPage;


// Claude 26 march buy now option
import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Layout from "../../Layout/Layout";
import FooterNew from "../../Layout/FooterNew";
import { useCart } from "../../../Context/CartContext";
import SEO from "../../SEO";
const API_URL = "https://ecom.cyberathon.com/index.php/Api/list_get_product";
const BASE_URL = "https://ecom.cyberathon.com/";
const FREE_SECONDS = 10;

// ─── Guest cart token ─────────────────────────────────────────────────────────
const getCartToken = () => {
  let token = localStorage.getItem("cart_token");
  if (!token) {
    token = crypto.randomUUID();
    localStorage.setItem("cart_token", token);
  }
  return token;
};

// ─── Helpers ──────────────────────────────────────────────────────────────────
function detectVideoType(url) {
  if (!url || url.trim() === "") return "no-video";
  const u = url.toLowerCase();
  if (u.includes("youtube.com") || u.includes("youtu.be")) return "youtube";
  if (
    u.endsWith(".mp4") || u.endsWith(".webm") || u.endsWith(".ogg") ||
    u.includes(".mp4?") || u.includes("gtv-videos-bucket") ||
    u.includes("commondatastorage.googleapis.com") || u.includes("archive.org")
  ) return "mp4";
  if (u.includes("vimeo.com") || u.includes("dailymotion.com")) return "iframe";
  return "mp4";
}

function buildYouTubeEmbedUrl(raw) {
  try {
    if (raw.includes("watch?v=")) {
      const id = new URLSearchParams(new URL(raw).search).get("v");
      return `https://www.youtube.com/embed/${id}`;
    }
    if (raw.includes("youtu.be/")) return `https://www.youtube.com/embed/${raw.split("youtu.be/")[1].split("?")[0]}`;
    if (raw.includes("embed/")) return raw;
  } catch (e) {}
  return raw;
}

function getYouTubeId(embedUrl) {
  if (!embedUrl) return "";
  const match = embedUrl.match(/embed\/([^?&]+)/);
  return match ? match[1] : "";
}

function loadYouTubeAPI() {
  if (window.YT && window.YT.Player) return Promise.resolve();
  if (window.__ytApiPromise) return window.__ytApiPromise;
  window.__ytApiPromise = new Promise((resolve) => {
    window.onYouTubeIframeAPIReady = resolve;
    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    document.body.appendChild(tag);
  });
  return window.__ytApiPromise;
}

const HtmlContent = ({ html, className = "" }) => {
  if (!html) return null;
  return <div className={className} dangerouslySetInnerHTML={{ __html: html }} />;
};

// ─── Add to Cart API (guest + logged-in) ─────────────────────────────────────
async function addToCartApi(prod_id, onSuccess, onError) {
  const userId    = sessionStorage.getItem("userId");
  const cartToken = !userId ? getCartToken() : null;

  if (!userId) {
    try {
      const listRes = await axios.post(
        "https://ecom.cyberathon.com/index.php/Api/list_cart",
        { user_id: null, cart_token: cartToken }
      );
      if (listRes.data.status) {
        const exists = listRes.data.cart_items.find(
          (i) => String(i.prod_id) === String(prod_id)
        );
        if (exists) { onSuccess(); return; }
      }
      const res = await axios.post(
        "https://ecom.cyberathon.com/index.php/Api/insert_cart",
        { user_id: null, prod_id: Number(prod_id), qty: 1, cart_token: cartToken }
      );
      if (res.data.status === true) {
        onSuccess();
      } else {
        sessionStorage.setItem("redirectAfterLogin", window.location.pathname);
        window.dispatchEvent(new Event("openLoginModal"));
      }
    } catch (e) {
      console.error(e);
      sessionStorage.setItem("redirectAfterLogin", window.location.pathname);
      window.dispatchEvent(new Event("openLoginModal"));
    }
    return;
  }

  // Logged-in
  try {
    const listRes = await axios.post(
      "https://ecom.cyberathon.com/index.php/Api/list_cart",
      { user_id: userId, cart_token: null }
    );
    if (listRes.data.status) {
      const exists = listRes.data.cart_items.find(
        (i) => String(i.prod_id) === String(prod_id)
      );
      if (exists) { onSuccess(); return; }
    }
    const res = await axios.post(
      "https://ecom.cyberathon.com/index.php/Api/insert_cart",
      { user_id: Number(userId), prod_id: Number(prod_id), qty: 1 }
    );
    if (res.data.status === true) onSuccess();
    else onError(res.data.message || "Failed to add");
  } catch (e) {
    console.error(e);
    onError("Something went wrong");
  }
}

// ─── ✅ UPDATED: Buy Now (no cart insert, direct navigate with product data) ──
async function buyNowApi(video, navigate, onError, setLoading) {
  const userId = sessionStorage.getItem("userId");

  if (!video?.prod_id) {
    onError("This item is not available.");
    return;
  }

  const buyNowProduct = {
    prod_id: video.prod_id,
    Product_name: video.heading || "",
    current_price: video.current_price || 0,
    qty: 1,
    size: "",
    Product_image: ""
  };

  // 🔴 user not logged in
  if (!userId) {

    // product save karo
    sessionStorage.setItem(
      "buyNowProduct",
      JSON.stringify(buyNowProduct)
    );

    // redirect after login
    sessionStorage.setItem(
      "redirectAfterLogin",
      "/Bill"
    );

    // login modal open
    window.dispatchEvent(
      new Event("openLoginModal")
    );

    setLoading(false);
    return;
  }

  // 🟢 user logged in
  navigate("/Bill", {
    state: {
      buyNow: true,
      product: buyNowProduct
    }
  });

  setLoading(false);
}

// ─── Map raw API product ──────────────────────────────────────────────────────
function mapProduct(p) {
  let rawUrl = p.video || p.video_url || p.product_video || "";
  if (rawUrl && !rawUrl.startsWith("http")) rawUrl = BASE_URL + rawUrl;
  const type = detectVideoType(rawUrl);
  let embedUrl = rawUrl;
  if (type === "youtube") embedUrl = buildYouTubeEmbedUrl(rawUrl);
  return {
    id: p.id || p.ref_id,
    prod_id: p.prod_id,
    heading: p.heading || p.product_name || p.title || "Untitled Course",
    description: p.description || "",
    details: p.details || "",
    current_price: p.current_price || 0,
    old_price: p.old_price || 0,
    type,
    embedUrl,
  };
}

// ─── Video Player ─────────────────────────────────────────────────────────────
// ✅ UPDATED: video full object pass ho raha hai buyNowApi ke liye
const VideoPlayer = ({ video, isPurchased, isAdded, onAddedChange, navigate, setCartCount }) => {
  const [phase, setPhase]         = useState("idle");
  const [loading, setLoading]     = useState(false);
  const [buyLoading, setBuyLoading] = useState(false);
  const videoRef  = useRef(null);
  const timerRef  = useRef(null);
  const playerRef = useRef(null);
  const divId = `detail-yt-${video.prod_id}`;

  const videoId = video.type === "youtube" ? getYouTubeId(video.embedUrl) : null;
  const thumbUrl = videoId ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg` : null;

  useEffect(() => {
    if (phase !== "playing" || video.type !== "mp4") return;
    const vid = videoRef.current;
    if (!vid || isPurchased) return;
    const onPlay = () => {
      timerRef.current = setTimeout(() => { vid.pause(); setPhase("locked"); }, FREE_SECONDS * 1000);
    };
    vid.addEventListener("play", onPlay);
    return () => { vid.removeEventListener("play", onPlay); clearTimeout(timerRef.current); };
  }, [phase, isPurchased, video.type]);

  const handlePlay = async () => {
    if (video.type === "youtube") {
      setPhase("playing");
      await loadYouTubeAPI();
      setTimeout(() => {
        playerRef.current = new window.YT.Player(divId, {
          events: {
            onReady: (e) => {
              e.target.playVideo();
              if (!isPurchased) {
                timerRef.current = setTimeout(() => {
                  e.target.pauseVideo(); setPhase("locked");
                }, FREE_SECONDS * 1000);
              }
            },
          },
        });
      }, 300);
    } else {
      setPhase("playing");
    }
  };

  const handleReplay = () => {
    clearTimeout(timerRef.current);
    if (playerRef.current) { try { playerRef.current.destroy(); } catch (e) {} playerRef.current = null; }
    setPhase("idle");
  };

  useEffect(() => () => {
    clearTimeout(timerRef.current);
    if (playerRef.current) { try { playerRef.current.destroy(); } catch (e) {} }
  }, []);

  const handleCartFromLock = async () => {
    setLoading(true);
    await addToCartApi(
      video.prod_id,
      () => { onAddedChange(true); setLoading(false); setCartCount(prev => prev + 1); },
      (msg) => { alert(msg); setLoading(false); }
    );
  };

  // ✅ UPDATED: video object pass karo
  const handleBuyFromLock = async () => {
    setBuyLoading(true);
    await buyNowApi(video, navigate, (msg) => { alert(msg); setBuyLoading(false); }, setBuyLoading);
  };

  if (video.type === "no-video") {
    return (
      <div className="vd-player-wrap vd-no-video">
        <svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1.2">
          <rect x="2" y="2" width="20" height="20" rx="2.5" />
          <path d="M10 8l6 4-6 4V8z" />
          <line x1="2" y1="2" x2="22" y2="22" />
        </svg>
        <p>No video available for this course</p>
      </div>
    );
  }

  return (
    <div className="vd-player-wrap">
      {isPurchased
        ? <span className="vd-badge vd-badge-purchased"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>Full Access Unlocked</span>
        : <span className="vd-badge vd-badge-preview"><svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21"/></svg>{FREE_SECONDS}s Free Preview</span>
      }

      {phase === "idle" && (
        <>
          {video.type === "youtube" && thumbUrl
            ? <img src={thumbUrl} alt={video.heading} className="vd-thumb" />
            : video.type === "mp4"
              ? <video src={`${video.embedUrl}#t=0.5`} className="vd-thumb" preload="metadata" muted playsInline />
              : <div className="vd-thumb" style={{ background: "#0d1117" }} />
          }
          <div className="vd-play-overlay" onClick={handlePlay}>
            <div className="vd-play-ripple" />
            <button className="vd-play-btn">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21"/></svg>
            </button>
            <p className="vd-play-hint">Click to play {isPurchased ? "full video" : "free preview"}</p>
          </div>
        </>
      )}

      {phase === "playing" && (
        <>
          {video.type === "youtube" && (
            <iframe id={divId} src={`https://www.youtube.com/embed/${videoId}?enablejsapi=1`} title={video.heading}
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen
              style={{ width: "100%", height: "100%", border: "none", display: "block" }} />
          )}
          {video.type === "mp4" && (
            <video ref={videoRef} src={video.embedUrl} controls={isPurchased} autoPlay playsInline
              onError={() => setPhase("error")} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
          )}
          {video.type === "iframe" && (
            <iframe src={video.embedUrl} title={video.heading} allow="autoplay; fullscreen" allowFullScreen
              style={{ width: "100%", height: "100%", border: "none", display: "block" }} />
          )}
        </>
      )}

      {phase === "locked" && (
        <>
          {video.type === "youtube" && thumbUrl && (
            <img src={thumbUrl} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", filter: "blur(8px) brightness(0.3)" }} />
          )}
          <div className="vd-lock-overlay">
            <div className="vd-lock-ring" />
            <div className="vd-lock-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
            </div>
            <h3 className="vd-lock-title">Preview Ended</h3>
            <p className="vd-lock-sub">Purchase this course to watch the full video</p>
            {video.prod_id && (
              <div className="vd-lock-actions">
                {/* Add to Cart */}
                <button className={`vd-btn-cart${isAdded ? " added" : ""}`} onClick={handleCartFromLock} disabled={loading || isAdded}>
                  {loading ? <span className="vd-spinner" /> :
                    isAdded
                      ? <><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg> Added to Cart</>
                      : <><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Add to Cart</>
                  }
                </button>
                {/* ✅ Buy Now from Lock Overlay */}
                <button className="vd-btn-buy-lock" onClick={handleBuyFromLock} disabled={buyLoading}>
                  {buyLoading ? <span className="vd-spinner" /> : "Buy Now"}
                </button>
              </div>
            )}
            <button className="vd-btn-replay" onClick={handleReplay}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-6"/></svg>
              Replay Preview
            </button>
          </div>
        </>
      )}

      {phase === "error" && (
        <div className="vd-error">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="1.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          <p>Video could not be loaded</p>
          <button className="vd-btn-retry" onClick={() => setPhase("idle")}>Try Again</button>
        </div>
      )}
    </div>
  );
};

// ─── MAIN DETAIL PAGE ─────────────────────────────────────────────────────────
const CourseSectionDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { setCartCount } = useCart();

  const [video, setVideo]             = useState(null);
  const [loading, setLoading]         = useState(true);
  const [isPurchased, setIsPurchased] = useState(false);
  const [isAdded, setIsAdded]         = useState(false);
  const [cartLoading, setCartLoading] = useState(false);
  const [buyLoading, setBuyLoading]   = useState(false);
  const [relatedVideos, setRelatedVideos] = useState([]);
 const [seoData, setSeoData] = useState({});
 useEffect(() => {
  const fetchSeo = async () => {
    try {
      const response = await axios.post(`${BASE_URL}index.php/Api/get_seo_by_page`, {
        page_name: 'courses_detail'   // <-- Important! page_name 'ebooks' rakho
      });

      if (response.data.status === 'true') {
        const data = response.data.data;
        setSeoData({
          title: data.meta_title,
          description: data.meta_description,
          keywords: data.meta_keywords,
          canonical: data.canonical_url,
        });
      }
    } catch (error) {
      console.error('SEO fetch error:', error);
    }
  };

  fetchSeo();
}, []);
  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(API_URL);
        if (!res.data?.status) { setLoading(false); return; }

        const products = Array.isArray(res.data.products) ? res.data.products : [];
        const all = products
          .filter((p) => p.product_type && p.product_type.toLowerCase() === "coursesection")
          .map(mapProduct);

        const found = all.find((v) => String(v.prod_id) === String(id));
        setVideo(found || null);
        setRelatedVideos(all.filter((v) => String(v.prod_id) !== String(id)).slice(0, 4));

        if (!found) { setLoading(false); return; }

        const userId    = sessionStorage.getItem("userId");
        const cartToken = localStorage.getItem("cart_token");

        if (userId || cartToken) {
          try {
            const cr = await axios.post("https://ecom.cyberathon.com/index.php/Api/list_cart", {
              user_id:    userId || null,
              cart_token: userId ? null : cartToken,
            });
            if (cr.data.status) {
              const inCart = cr.data.cart_items.some((i) => String(i.prod_id) === String(found.prod_id));
              setIsAdded(inCart);
              setCartCount(cr.data.cart_items.length);
            }
          } catch (e) {}
        }

        if (userId) {
          try {
            const or = await axios.post("https://ecom.cyberathon.com/index.php/Api/list_new_order", {
              user_id: parseInt(userId),
            });
            if (or.data.status && Array.isArray(or.data.orders)) {
              const purchased = or.data.orders.some((order) =>
                Array.isArray(order.items) &&
                order.items.some((item) => {
                  if (String(item.prod_id) !== String(found.prod_id)) return false;
                  return (
                    item.access === "unlocked" ||
                    order.purchase_status === "yes" ||
                    order.payment_status === "Paid" ||
                    order.payment_status === "paid" ||
                    order.order_status === "Delivered" ||
                    order.order_status === "Completed"
                  );
                })
              );
              setIsPurchased(purchased);
            }
          } catch (e) {}
        }
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };

    load();
    window.scrollTo(0, 0);

    const onLogin = () => load();
    window.addEventListener("userLoggedIn", onLogin);
    return () => window.removeEventListener("userLoggedIn", onLogin);
  }, [id]);

  // ── Add to Cart handler ──────────────────────────────────────────────────
  const handleAddToCart = () => {
    if (isAdded || cartLoading || !video?.prod_id) return;
    setCartLoading(true);
    addToCartApi(
      video.prod_id,
      () => { setIsAdded(true); setCartLoading(false); setCartCount(prev => prev + 1); },
      (msg) => { alert(msg); setCartLoading(false); }
    );
  };

  // ✅ UPDATED: Buy Now handler — video object pass karo
  const handleBuyNow = () => {
    if (buyLoading || !video?.prod_id) return;
    setBuyLoading(true);
    buyNowApi(video, navigate, (msg) => { alert(msg); setBuyLoading(false); }, setBuyLoading);
  };

  // ── Loading skeleton ──────────────────────────────────────────────────────
  if (loading) {
    return (
      <>
        <style>{detailStyles}</style>
        <div className="vd-root">
          <div className="vd-skeleton-wrap">
            <div className="vd-skeleton" style={{ height: 480, borderRadius: 20, marginBottom: 32 }} />
            <div className="vd-skeleton" style={{ height: 28, width: "60%", marginBottom: 16 }} />
            <div className="vd-skeleton" style={{ height: 16, width: "80%", marginBottom: 10 }} />
            <div className="vd-skeleton" style={{ height: 16, width: "70%" }} />
          </div>
        </div>
      </>
    );
  }

  // ── Not Found ─────────────────────────────────────────────────────────────
  if (!video) {
    return (
      <>
        <style>{detailStyles}</style>
        <div className="vd-root">
          <div className="vd-not-found">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            <h2>Course Not Found</h2>
            <p>This course doesn't exist or has been removed.</p>
            <button className="vd-back-btn" onClick={() => navigate(-1)}>← Go Back</button>
          </div>
        </div>
      </>
    );
  }

  const hasPaid = video.current_price && Number(video.current_price) > 0;

  return (
    <>
    <SEO
      title={seoData.title || "best cupping therapy tools ,authentic cupping supplies | shopeindia"}
      description={seoData.description || "Explore our collection of ebooks on ShopIndia."}
      keywords={seoData.keywords || "ebooks, ShopIndia, books, pdf"}
      canonical={seoData.canonical || "https://www.shopindia.com/ebooks"}
    />
      <Layout />
      <style>{detailStyles}</style>
      <div className="vd-root">

        {/* Breadcrumb */}
        <div className="vd-breadcrumb">
          <button onClick={() => navigate(-1)} className="vd-back-link">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="15 18 9 12 15 6"/></svg>
            Back to Courses
          </button>
          <span className="vd-breadcrumb-sep">/</span>
          <span className="vd-breadcrumb-current">{video.heading}</span>
        </div>

        <div className="vd-layout">
          <div className="vd-main">

            {/* ✅ Video Player — poora video object pass ho raha hai */}
            <VideoPlayer
              video={video}
              isPurchased={isPurchased}
              isAdded={isAdded}
              onAddedChange={setIsAdded}
              navigate={navigate}
              setCartCount={setCartCount}
            />

            <div className="vd-info-block">
              <div className="vd-title-row">
                <h1 className="vd-title">{video.heading}</h1>
                {isPurchased && (
                  <span className="vd-purchased-chip">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                    Purchased
                  </span>
                )}
              </div>

              {/* Mobile CTA */}
              <div className="vd-mobile-cta">
                <div className="vd-price-row">
                  {hasPaid ? (
                    <>
                      <span className="vd-price-current">₹{Number(video.current_price).toLocaleString("en-IN")}</span>
                      {video.old_price && Number(video.old_price) > 0 && (
                        <span className="vd-price-old">₹{Number(video.old_price).toLocaleString("en-IN")}</span>
                      )}
                    </>
                  ) : (
                    <span className="vd-price-free">Free</span>
                  )}
                </div>
                {video.prod_id && !isPurchased && (
                  <div className="vd-mobile-action-row">
                    <button className={`vd-btn-add-mobile${isAdded ? " added" : ""}`} onClick={handleAddToCart} disabled={cartLoading || isAdded}>
                      {cartLoading ? <span className="vd-spinner" /> :
                        isAdded
                          ? <><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg> Added</>
                          : <><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Add to Cart</>
                      }
                    </button>
                    {/* ✅ Mobile Buy Now */}
                    <button className="vd-btn-buy-mobile" onClick={handleBuyNow} disabled={buyLoading}>
                      {buyLoading ? <span className="vd-spinner" /> : "Buy Now"}
                    </button>
                  </div>
                )}
              </div>

              {/* Content sections */}
              <div className="vd-tabs-section">
                {video.description && (
                  <div className="vd-section">
                    <h3 className="vd-section-title">
                      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                      About This Course
                    </h3>
                    <div className="vd-html-content"><HtmlContent html={video.description} /></div>
                  </div>
                )}
                {video.details && (
                  <div className="vd-section">
                    <h3 className="vd-section-title">
                      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
                      What You'll Learn
                    </h3>
                    <div className="vd-html-content vd-learn-list"><HtmlContent html={video.details} /></div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* RIGHT Sidebar */}
          <div className="vd-sidebar">
            <div className="vd-sidebar-card">
              {/* Thumbnail */}
              <div className="vd-sidebar-thumb">
                {video.type === "youtube" && getYouTubeId(video.embedUrl) ? (
                  <img src={`https://img.youtube.com/vi/${getYouTubeId(video.embedUrl)}/hqdefault.jpg`} alt={video.heading} />
                ) : video.type === "mp4" ? (
                  <video src={`${video.embedUrl}#t=0.5`} muted playsInline preload="metadata" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                ) : (
                  <div style={{ width: "100%", height: "100%", background: "linear-gradient(135deg,#0d1117,#1a2332)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="1.2"><rect x="2" y="2" width="20" height="20" rx="2.5"/><path d="M10 8l6 4-6 4V8z"/></svg>
                  </div>
                )}
                <div className="vd-sidebar-thumb-overlay">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21"/></svg>
                </div>
              </div>

              {/* Price */}
              <div className="vd-sidebar-price-row">
                {hasPaid ? (
                  <>
                    <span className="vd-sidebar-price-current">₹{Number(video.current_price).toLocaleString("en-IN")}</span>
                    {video.old_price && Number(video.old_price) > 0 && (
                      <span className="vd-sidebar-price-old">₹{Number(video.old_price).toLocaleString("en-IN")}</span>
                    )}
                  </>
                ) : (
                  <span className="vd-sidebar-price-free">Free</span>
                )}
              </div>

              {/* CTA */}
              {!video.prod_id ? (
                <div className="vd-no-purchase">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                  Not available for purchase
                </div>
              ) : isPurchased ? (
                <div className="vd-owned-block">
                  <div className="vd-owned-badge">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                    You own this course
                  </div>
                  <p className="vd-owned-sub">You have full lifetime access</p>
                </div>
              ) : (
                <div className="vd-cta-stack">
                  {/* Add to Cart */}
                  <button
                    className={`vd-btn-addcart${isAdded ? " added" : ""}`}
                    onClick={handleAddToCart}
                    disabled={cartLoading || isAdded}
                  >
                    {cartLoading ? (
                      <span className="vd-spinner vd-spinner-teal" />
                    ) : isAdded ? (
                      <><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg> Added to Cart</>
                    ) : (
                      <><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Add to Cart</>
                    )}
                  </button>
                  {/* ✅ Sidebar Buy Now */}
                  <button
                    className="vd-btn-buynow"
                    onClick={handleBuyNow}
                    disabled={buyLoading}
                  >
                    {buyLoading ? <span className="vd-spinner" /> : "Buy Now"}
                  </button>
                </div>
              )}

              {/* Perks */}
              <ul className="vd-perks">
                <li><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>Lifetime access after purchase</li>
                <li><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>Watch on any device</li>
                <li><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>Free {FREE_SECONDS}s preview available</li>
              </ul>
            </div>

            {/* Related Videos */}
            {relatedVideos.length > 0 && (
              <div className="vd-related">
                <h3 className="vd-related-title">More Courses</h3>
                <div className="vd-related-list">
                  {relatedVideos.map((rv) => {
                    const rvId = rv.type === "youtube" ? getYouTubeId(rv.embedUrl) : null;
                    return (
                      <div key={rv.prod_id} className="vd-related-item"
                        onClick={() => navigate(`/coursesectiondetail/${rv.prod_id}`)}>
                        <div className="vd-related-thumb">
                          {rvId
                            ? <img src={`https://img.youtube.com/vi/${rvId}/hqdefault.jpg`} alt={rv.heading} />
                            : rv.type === "mp4"
                              ? <video src={`${rv.embedUrl}#t=0.5`} muted playsInline preload="metadata" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                              : <div className="vd-related-no-thumb"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1.5"><rect x="2" y="2" width="20" height="20" rx="2"/><path d="M10 8l6 4-6 4V8z"/></svg></div>
                          }
                          <div className="vd-related-play">
                            <svg width="10" height="10" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21"/></svg>
                          </div>
                        </div>
                        <div className="vd-related-info">
                          <p className="vd-related-name">{rv.heading}</p>
                          <p className="vd-related-price">
                            {rv.current_price && Number(rv.current_price) > 0
                              ? `₹${Number(rv.current_price).toLocaleString("en-IN")}`
                              : "Free"}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <FooterNew />
    </>
  );
};

// ─── STYLES ───────────────────────────────────────────────────────────────────
const detailStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=DM+Sans:ital,wght@0,400;0,500;0,600;1,400&display=swap');

  :root {
    --vd-teal: #0ecfce;
    --vd-teal-dark: #0ab5b4;
    --vd-green: #22c55e;
    --vd-green-dark: #16a34a;
    --vd-amber: #f59e0b;
    --vd-amber-dark: #d97706;
    --vd-text-primary: #0f172a;
    --vd-text-secondary: #475569;
    --vd-text-muted: #94a3b8;
    --vd-surface: #f7fffe;
    --vd-card-bg: #ffffff;
    --vd-border: #e5f0f0;
    --vd-sidebar-w: 340px;
  }

  .vd-root { background: var(--vd-surface); min-height: 100vh; padding: 28px 0 80px; font-family: 'DM Sans', sans-serif; }

  .vd-breadcrumb { display: flex; align-items: center; gap: 8px; padding: 0 28px 22px; max-width: 1280px; margin: 0 auto; font-size: 13.5px; color: var(--vd-text-muted); flex-wrap: wrap; }
  .vd-back-link { display: flex; align-items: center; gap: 4px; color: var(--vd-teal); background: none; border: none; cursor: pointer; font-size: 13.5px; font-weight: 600; padding: 0; font-family: 'DM Sans', sans-serif; transition: opacity 0.2s; }
  .vd-back-link:hover { opacity: 0.75; }
  .vd-breadcrumb-sep { color: #cbd5e1; }
  .vd-breadcrumb-current { color: var(--vd-text-secondary); font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 260px; }

  .vd-layout { display: flex; gap: 32px; padding: 0 28px; max-width: 1280px; margin: 0 auto; align-items: flex-start; }
  .vd-main { flex: 1; min-width: 0; }

  .vd-player-wrap { position: relative; width: 100%; aspect-ratio: 16/9; background: #0d1117; border-radius: 20px; overflow: hidden; margin-bottom: 28px; box-shadow: 0 8px 40px rgba(0,0,0,0.12); }
  .vd-thumb { width: 100%; height: 100%; object-fit: cover; display: block; }
  .vd-play-overlay { position: absolute; inset: 0; background: linear-gradient(to top, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.1) 60%, transparent 100%); display: flex; flex-direction: column; align-items: center; justify-content: center; cursor: pointer; gap: 14px; transition: background 0.2s; }
  .vd-play-overlay:hover { background: linear-gradient(to top, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.2) 60%, transparent 100%); }
  .vd-play-ripple { position: absolute; width: 100px; height: 100px; border-radius: 50%; border: 1.5px solid rgba(14,207,206,0.3); animation: vdRipple 2s ease-in-out infinite; pointer-events: none; }
  @keyframes vdRipple { 0%,100% { transform: scale(1); opacity: 0.6; } 50% { transform: scale(1.4); opacity: 0; } }
  .vd-play-btn { width: 72px; height: 72px; border-radius: 50%; background: var(--vd-teal); border: 3px solid rgba(255,255,255,0.25); display: flex; align-items: center; justify-content: center; cursor: pointer; position: relative; z-index: 2; transition: transform 0.2s cubic-bezier(.22,.68,0,1.4), background 0.2s; box-shadow: 0 6px 32px rgba(14,207,206,0.5); }
  .vd-play-btn:hover { transform: scale(1.1); background: var(--vd-teal-dark); }
  .vd-play-btn svg { margin-left: 4px; }
  .vd-play-hint { font-size: 13px; color: rgba(255,255,255,0.7); font-family: 'DM Sans', sans-serif; font-weight: 500; position: relative; z-index: 2; margin: 0; }

  .vd-badge { position: absolute; top: 16px; left: 16px; z-index: 8; display: inline-flex; align-items: center; gap: 5px; font-size: 12px; font-weight: 700; padding: 5px 12px; border-radius: 100px; backdrop-filter: blur(8px); font-family: 'Plus Jakarta Sans', sans-serif; letter-spacing: 0.2px; }
  .vd-badge-preview { background: rgba(14,207,206,0.2); color: #fff; border: 1px solid rgba(14,207,206,0.45); }
  .vd-badge-purchased { background: rgba(34,197,94,0.2); color: #fff; border: 1px solid rgba(34,197,94,0.45); }

  .vd-lock-overlay { position: absolute; inset: 0; background: rgba(6,10,18,0.92); backdrop-filter: blur(8px); display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 10px; z-index: 10; padding: 28px; text-align: center; animation: vdLockIn 0.2s ease; }
  @keyframes vdLockIn { from { opacity: 0; transform: scale(0.98); } to { opacity: 1; transform: scale(1); } }
  .vd-lock-ring { position: absolute; width: 110px; height: 110px; border-radius: 50%; border: 1.5px solid rgba(14,207,206,0.2); animation: vdRipple 2s ease-in-out infinite; pointer-events: none; }
  .vd-lock-icon { width: 70px; height: 70px; border-radius: 50%; background: rgba(14,207,206,0.1); border: 1.5px solid rgba(14,207,206,0.3); display: flex; align-items: center; justify-content: center; position: relative; z-index: 1; }
  .vd-lock-title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 20px; font-weight: 800; color: #f1f5f9; margin: 4px 0 0; letter-spacing: -0.3px; }
  .vd-lock-sub { font-size: 13.5px; color: #64748b; margin: 0; max-width: 280px; line-height: 1.55; }
  .vd-lock-actions { display: flex; gap: 10px; margin-top: 4px; flex-wrap: wrap; justify-content: center; }

  .vd-btn-cart { background: linear-gradient(135deg, #24aeb1, #058587); color: #fff; border: none; border-radius: 12px; padding: 11px 22px; font-size: 14px; font-weight: 700; cursor: pointer; display: flex; align-items: center; gap: 8px; transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s; font-family: 'Plus Jakarta Sans', sans-serif; box-shadow: 0 2px 12px rgba(36,174,177,0.35); }
  .vd-btn-cart:hover:not(:disabled):not(.added) { opacity: 0.88; transform: translateY(-1px); box-shadow: 0 4px 18px rgba(36,174,177,0.5); }
  .vd-btn-cart.added { background: linear-gradient(135deg, #24aeb1, #058587); cursor: default; opacity: 0.85; }
  .vd-btn-cart:disabled:not(.added) { opacity: 0.7; cursor: not-allowed; }

  .vd-btn-buy-lock { background: linear-gradient(135deg, #24aeb1, #058587); color: #fff; border: none; border-radius: 12px; padding: 11px 22px; font-size: 14px; font-weight: 700; cursor: pointer; display: flex; align-items: center; gap: 8px; transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s; font-family: 'Plus Jakarta Sans', sans-serif; box-shadow: 0 2px 12px rgba(36,174,177,0.35); }
  .vd-btn-buy-lock:hover:not(:disabled) { opacity: 0.88; transform: translateY(-1px); box-shadow: 0 4px 18px rgba(36,174,177,0.5); }
  .vd-btn-buy-lock:disabled { opacity: 0.7; cursor: not-allowed; }

  .vd-btn-replay { background: transparent; color: #475569; border: 1px solid #2d3748; border-radius: 10px; padding: 11px 20px; font-size: 13px; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 6px; transition: color 0.2s, border-color 0.2s; font-family: 'DM Sans', sans-serif; }
  .vd-btn-replay:hover { color: #94a3b8; border-color: #475569; }

  .vd-no-video { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 12px; }
  .vd-no-video p { color: rgba(255,255,255,0.2); font-size: 13px; margin: 0; }
  .vd-error { width: 100%; height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 12px; padding: 20px; }
  .vd-error p { color: rgba(255,255,255,0.25); font-size: 13px; margin: 0; }
  .vd-btn-retry { background: rgba(14,207,206,0.12); color: var(--vd-teal); border: 1px solid rgba(14,207,206,0.3); border-radius: 8px; padding: 6px 16px; font-size: 12px; font-weight: 600; cursor: pointer; font-family: 'DM Sans', sans-serif; transition: background 0.2s; }
  .vd-btn-retry:hover { background: rgba(14,207,206,0.2); }

  .vd-info-block { padding-bottom: 40px; }
  .vd-title-row { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; margin-bottom: 16px; flex-wrap: wrap; }
  .vd-title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: clamp(1.45rem, 2.5vw, 2rem); font-weight: 800; color: var(--vd-text-primary); margin: 0; letter-spacing: -0.5px; line-height: 1.25; flex: 1; }
  .vd-purchased-chip { display: inline-flex; align-items: center; gap: 5px; background: #f0fdf4; color: var(--vd-green-dark); border: 1px solid #bbf7d0; border-radius: 100px; font-size: 12px; font-weight: 700; padding: 5px 12px; font-family: 'Plus Jakarta Sans', sans-serif; white-space: nowrap; flex-shrink: 0; }

  .vd-mobile-cta { display: none; flex-direction: column; gap: 10px; padding: 16px 0; border-bottom: 1px solid #f1f5f9; margin-bottom: 20px; }
  .vd-price-row { display: flex; align-items: baseline; gap: 8px; }
  .vd-price-current { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 26px; font-weight: 800; color: var(--vd-green); letter-spacing: -0.6px; }
  .vd-price-old { font-size: 14px; color: var(--vd-text-muted); text-decoration: line-through; font-weight: 500; }
  .vd-price-free { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 22px; font-weight: 800; color: var(--vd-teal); }

  .vd-mobile-action-row { display: flex; gap: 8px; }
  .vd-btn-add-mobile { flex: 1; padding: 10px 0; border-radius: 10px; border: none; background: linear-gradient(135deg, #24aeb1, #058587); color: #fff; font-size: 13.5px; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 6px; transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s; font-family: 'Plus Jakarta Sans', sans-serif; white-space: nowrap; box-shadow: 0 2px 10px rgba(36,174,177,0.35); }
  .vd-btn-add-mobile:hover:not(:disabled):not(.added) { opacity: 0.88; transform: translateY(-1px); box-shadow: 0 4px 16px rgba(36,174,177,0.5); }
  .vd-btn-add-mobile.added { opacity: 0.8; cursor: default; }
  .vd-btn-add-mobile:disabled:not(.added) { opacity: 0.65; cursor: not-allowed; }

  .vd-btn-buy-mobile { flex: 1; padding: 10px 0; border-radius: 10px; border: none; background: linear-gradient(135deg, #24aeb1, #058587); color: #fff; font-size: 13.5px; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s; font-family: 'Plus Jakarta Sans', sans-serif; box-shadow: 0 2px 10px rgba(36,174,177,0.35); }
  .vd-btn-buy-mobile:hover:not(:disabled) { opacity: 0.88; transform: translateY(-1px); box-shadow: 0 4px 16px rgba(36,174,177,0.5); }
  .vd-btn-buy-mobile:disabled { opacity: 0.65; cursor: not-allowed; }

  .vd-tabs-section { display: flex; flex-direction: column; gap: 28px; }
  .vd-section { background: var(--vd-card-bg); border: 1.5px solid var(--vd-border); border-radius: 16px; padding: 24px 26px; animation: vdFadeUp 0.4s ease both; }
  @keyframes vdFadeUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
  .vd-section-title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 15px; font-weight: 700; color: var(--vd-text-primary); margin: 0 0 16px; display: flex; align-items: center; gap: 8px; padding-bottom: 12px; border-bottom: 1px solid #f1f5f9; }
  .vd-section-title svg { color: var(--vd-teal); flex-shrink: 0; }
  .vd-html-content p { font-size: 14.5px; color: var(--vd-text-secondary); line-height: 1.75; margin: 0 0 8px; }
  .vd-html-content ul, .vd-html-content ol { padding-left: 22px; margin: 6px 0; }
  .vd-html-content li { font-size: 14.5px; color: var(--vd-text-secondary); line-height: 1.7; margin-bottom: 5px; list-style-type: disc; }
  .vd-html-content ol li { list-style-type: decimal; }
  .vd-html-content strong { color: var(--vd-text-primary); font-weight: 700; }
  .vd-html-content a { color: var(--vd-teal); text-decoration: none; }

  .vd-sidebar { width: var(--vd-sidebar-w); flex-shrink: 0; position: sticky; top: 24px; display: flex; flex-direction: column; gap: 20px; }
  .vd-sidebar-card { background: var(--vd-card-bg); border: 1.5px solid var(--vd-border); border-radius: 20px; overflow: hidden; box-shadow: 0 4px 24px rgba(0,0,0,0.05); animation: vdFadeUp 0.4s ease both; }
  .vd-sidebar-thumb { width: 100%; height: 185px; overflow: hidden; position: relative; background: #0d1117; }
  .vd-sidebar-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
  .vd-sidebar-thumb-overlay { position: absolute; inset: 0; background: rgba(0,0,0,0.3); display: flex; align-items: center; justify-content: center; }
  .vd-sidebar-thumb-overlay svg { opacity: 0.7; }
  .vd-sidebar-price-row { padding: 18px 20px 0; display: flex; align-items: baseline; gap: 10px; flex-wrap: wrap; }
  .vd-sidebar-price-current { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 28px; font-weight: 800; color: var(--vd-green); letter-spacing: -0.7px; }
  .vd-sidebar-price-old { font-size: 14px; color: var(--vd-text-muted); text-decoration: line-through; }
  .vd-sidebar-price-free { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 22px; font-weight: 800; color: var(--vd-teal); }

  .vd-cta-stack { padding: 14px 20px 16px; display: flex; flex-direction: column; gap: 10px; }

  .vd-btn-addcart { width: 100%; padding: 13px 0; border-radius: 12px; border: none; background: linear-gradient(135deg, #24aeb1, #058587); color: #fff; font-size: 14.5px; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s; font-family: 'Plus Jakarta Sans', sans-serif; box-shadow: 0 2px 14px rgba(36,174,177,0.35); }
  .vd-btn-addcart:hover:not(:disabled):not(.added) { opacity: 0.88; transform: translateY(-1px); box-shadow: 0 4px 20px rgba(36,174,177,0.5); }
  .vd-btn-addcart.added { opacity: 0.8; cursor: default; }
  .vd-btn-addcart:disabled:not(.added) { opacity: 0.65; cursor: not-allowed; }

  .vd-btn-buynow { width: 100%; padding: 13px 0; border-radius: 12px; border: none; background: linear-gradient(135deg, #24aeb1, #058587); color: #fff; font-size: 14.5px; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s; font-family: 'Plus Jakarta Sans', sans-serif; box-shadow: 0 2px 14px rgba(36,174,177,0.35); }
  .vd-btn-buynow:hover:not(:disabled) { opacity: 0.88; transform: translateY(-1px); box-shadow: 0 4px 20px rgba(36,174,177,0.5); }
  .vd-btn-buynow:disabled { opacity: 0.65; cursor: not-allowed; }

  .vd-owned-block { padding: 14px 20px 16px; }
  .vd-owned-badge { display: flex; align-items: center; gap: 7px; background: #f0fdf4; color: var(--vd-green-dark); border: 1px solid #bbf7d0; border-radius: 10px; padding: 10px 14px; font-size: 13.5px; font-weight: 700; font-family: 'Plus Jakarta Sans', sans-serif; margin-bottom: 8px; }
  .vd-owned-sub { font-size: 12.5px; color: var(--vd-text-muted); margin: 0; padding: 0 2px; }
  .vd-no-purchase { display: flex; align-items: center; gap: 6px; color: var(--vd-text-muted); font-size: 13px; padding: 14px 20px 16px; }

  .vd-perks { list-style: none; margin: 0; padding: 14px 20px 20px; border-top: 1px solid #f1f5f9; display: flex; flex-direction: column; gap: 9px; }
  .vd-perks li { display: flex; align-items: center; gap: 8px; font-size: 13px; color: var(--vd-text-secondary); font-family: 'DM Sans', sans-serif; }

  .vd-related { background: var(--vd-card-bg); border: 1.5px solid var(--vd-border); border-radius: 20px; overflow: hidden; }
  .vd-related-title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 14px; font-weight: 700; color: var(--vd-text-primary); padding: 16px 18px 12px; border-bottom: 1px solid #f1f5f9; margin: 0; }
  .vd-related-list { padding: 8px 0; }
  .vd-related-item { display: flex; gap: 12px; padding: 10px 16px; cursor: pointer; transition: background 0.15s; align-items: center; }
  .vd-related-item:hover { background: #f8fffe; }
  .vd-related-thumb { width: 76px; height: 50px; border-radius: 8px; overflow: hidden; flex-shrink: 0; background: #0d1117; position: relative; }
  .vd-related-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
  .vd-related-no-thumb { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; }
  .vd-related-play { position: absolute; inset: 0; background: rgba(0,0,0,0.3); display: flex; align-items: center; justify-content: center; }
  .vd-related-info { flex: 1; min-width: 0; }
  .vd-related-name { font-size: 13px; font-weight: 600; color: var(--vd-text-primary); margin: 0 0 4px; line-height: 1.35; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-family: 'Plus Jakarta Sans', sans-serif; }
  .vd-related-price { font-size: 12.5px; font-weight: 700; color: var(--vd-green); margin: 0; }

  .vd-spinner { display: inline-block; width: 16px; height: 16px; border: 2px solid rgba(255,255,255,0.3); border-top-color: #fff; border-radius: 50%; animation: vdSpin 0.7s linear infinite; }
  .vd-spinner-teal { border-color: rgba(14,207,206,0.3); border-top-color: var(--vd-teal); }
  @keyframes vdSpin { to { transform: rotate(360deg); } }

  .vd-skeleton-wrap { max-width: 900px; margin: 0 auto; padding: 0 28px; }
  .vd-skeleton { background: linear-gradient(90deg, #f8fafc 25%, #f1f5f9 50%, #f8fafc 75%); background-size: 200% 100%; animation: vdSkel 1.5s ease-in-out infinite; }
  @keyframes vdSkel { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }

  .vd-not-found { text-align: center; padding: 80px 20px; display: flex; flex-direction: column; align-items: center; gap: 12px; }
  .vd-not-found h2 { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 24px; font-weight: 800; color: var(--vd-text-primary); margin: 0; }
  .vd-not-found p { color: var(--vd-text-muted); margin: 0; font-size: 15px; }
  .vd-back-btn { background: var(--vd-teal); color: #fff; border: none; border-radius: 10px; padding: 10px 22px; font-size: 14px; font-weight: 700; cursor: pointer; font-family: 'Plus Jakarta Sans', sans-serif; margin-top: 8px; transition: opacity 0.2s; }
  .vd-back-btn:hover { opacity: 0.87; }

  @media (max-width: 1024px) { :root { --vd-sidebar-w: 290px; } }
  @media (max-width: 820px) {
    .vd-layout { flex-direction: column; }
    .vd-sidebar { width: 100%; position: static; }
    .vd-mobile-cta { display: flex; }
    .vd-sidebar-card .vd-cta-stack, .vd-sidebar-card .vd-owned-block { display: none; }
    .vd-player-wrap { border-radius: 14px; }
    .vd-layout { padding: 0 16px; }
    .vd-breadcrumb { padding: 0 16px 18px; }
  }
  @media (max-width: 480px) {
    .vd-root { padding: 16px 0 60px; }
    .vd-title { font-size: 1.35rem; }
    .vd-lock-actions { flex-direction: column; width: 100%; }
    .vd-btn-cart, .vd-btn-buy-lock, .vd-btn-replay { width: 100%; justify-content: center; }
    .vd-mobile-action-row { flex-direction: column; }
  }
`;

export default CourseSectionDetailPage;